import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  CheckoutPaymentsAction: { input: any; output: any; }
  Date: { input: any; output: any; }
  DateTime: { input: any; output: any; }
  FlowContext: { input: any; output: any; }
  Instant: { input: any; output: any; }
  JSON: { input: any; output: any; }
  PaymentMethodDetails: { input: any; output: any; }
  PaymentMethodsResponse: { input: any; output: any; }
  /**
   * The raw insurance-related data that can be given to a `PriceIntent` in order to generate offers.
   * This data is mostly related to the insured object itself, and not the "holder" of the insurance.
   *
   * Examples of common fields:
   * - `street`
   * - `zipCode`
   * - `registrationNumber` (car)
   *
   * Examples of fields not found here:
   * - `firstName` (see: `ShopSession.customer`)
   * - `email` (see: `ShopSession.customer`)
   */
  PricingFormData: { input: any; output: any; }
  UUID: { input: string; output: string; }
  Url: { input: any; output: any; }
  join__FieldSet: { input: any; output: any; }
  link__Import: { input: any; output: any; }
};

export enum AgreementCreationCause {
  /**
   * This agreement was created by some kind of intervening change to the insurance, such as a move, co-insured change
   * or similar.
   */
  MidtermChange = 'MIDTERM_CHANGE',
  /** This agreement was created as part of a contract creation. This means it's the first agreement of said contract. */
  NewContract = 'NEW_CONTRACT',
  /** This agreement was created as part of the automatic renewal process of insurances. Usually yearly. */
  Renewal = 'RENEWAL',
  /**
   * No creation cause is known - this is due to the agreement being older than when we started tracking
   * creation cause.
   */
  Unknown = 'UNKNOWN'
}

export enum AppPlatform {
  Android = 'ANDROID',
  Ios = 'IOS'
}

export type BrowserInfo = {
  acceptHeader: Scalars['String']['input'];
  colorDepth: Scalars['Int']['input'];
  javaEnabled: Scalars['Boolean']['input'];
  language: Scalars['String']['input'];
  screenHeight: Scalars['Int']['input'];
  screenWidth: Scalars['Int']['input'];
  timeZoneOffset: Scalars['Int']['input'];
  userAgent: Scalars['String']['input'];
};

export enum CampaignDiscountType {
  /** Free for a number of months. This means `CampaignDiscount.months` is non-zero. */
  FreeMonths = 'FREE_MONTHS',
  /** A percentage discount indefinitely. This means `CampaignDiscount.percentage` is non-zero. */
  IndefinitePercentage = 'INDEFINITE_PERCENTAGE',
  /** A fixed deduction of cost. This means `CampaignDiscount.amount` is non-zero. */
  MonthlyCost = 'MONTHLY_COST',
  /**
   * A percentage discount for a number of months. This means both `CampaignDiscount.months`
   * and `CampaignDiscount.percentage` are non-zero.
   */
  MonthlyPercentage = 'MONTHLY_PERCENTAGE',
  /**
   * A hack-case to support tagging the member with some kind of partner source. This isn't an actual discount,
   * but we want to display it someplace.
   */
  VisibleNoDiscount = 'VISIBLE_NO_DISCOUNT'
}

export type ChangeTierDeductibleCommitIntentInput = {
  /** The quote to activate. */
  quoteId: Scalars['ID']['input'];
};

export type ChangeTierDeductibleCreateIntentInput = {
  /** The contract to change. */
  contractId: Scalars['ID']['input'];
  /** The source for changing tier/deductible. */
  source: ChangeTierDeductibleSource;
};

export enum ChangeTierDeductibleSource {
  SelfService = 'SELF_SERVICE',
  TerminationBetterCoverage = 'TERMINATION_BETTER_COVERAGE',
  TerminationBetterPrice = 'TERMINATION_BETTER_PRICE'
}

export enum ChatMessageSender {
  Hedvig = 'HEDVIG',
  Member = 'MEMBER'
}

export enum ClaimOutcome {
  NotCompensated = 'NOT_COMPENSATED',
  NotCovered = 'NOT_COVERED',
  Paid = 'PAID',
  Unresponsive = 'UNRESPONSIVE'
}

export enum ClaimStatus {
  Closed = 'CLOSED',
  Created = 'CREATED',
  InProgress = 'IN_PROGRESS',
  Reopened = 'REOPENED'
}

export type CoInsuredInput = {
  birthdate?: InputMaybe<Scalars['Date']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationSendMessageInput = {
  fileUploadToken?: InputMaybe<Scalars['String']['input']>;
  /** The conversation ID the message should be sent to */
  id: Scalars['UUID']['input'];
  /** Optional client-generated ID for the message */
  messageId?: InputMaybe<Scalars['UUID']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
};

export type ConversationStartInput = {
  /** The to-be `Conversation.id` of the returned Conversation. Should be a UUID v4. */
  id: Scalars['UUID']['input'];
};

export enum CountryCode {
  /** Denmark */
  Dk = 'DK',
  /** Norway */
  No = 'NO',
  /** Sweden */
  Se = 'SE'
}

export enum CrossSellSource {
  Addon = 'ADDON',
  ChangeTier = 'CHANGE_TIER',
  ClosedClam = 'CLOSED_CLAM',
  EditCoinsured = 'EDIT_COINSURED',
  Home = 'HOME',
  MovingFlow = 'MOVING_FLOW'
}

export enum CrossSellType {
  Accident = 'ACCIDENT',
  ApartmentBrf = 'APARTMENT_BRF',
  ApartmentRent = 'APARTMENT_RENT',
  Car = 'CAR',
  Home = 'HOME',
  Pet = 'PET',
  PetCat = 'PET_CAT',
  PetDog = 'PET_DOG'
}

export enum CurrencyCode {
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK'
}

export type EntrypointSearchInput = {
  entrypointGroupId?: InputMaybe<Scalars['ID']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  searchString?: InputMaybe<Scalars['String']['input']>;
  type: EntrypointType;
};

export enum EntrypointType {
  Claim = 'CLAIM'
}

/** Input for `Mutation.sendEvent` */
export type EventInput = {
  /** The client timestamp. */
  clientTimestamp: Scalars['DateTime']['input'];
  /** The event data. */
  data: Scalars['JSON']['input'];
  /** The id of the event. */
  id: Scalars['ID']['input'];
  /** The session the event belongs to. */
  sessionId: Scalars['ID']['input'];
  /** The event type. */
  type: Scalars['String']['input'];
};

export enum ExternalInsuranceCancellationOption {
  /** We can offer cancellation based on internal IEX work at Hedvig. */
  Iex = 'IEX',
  /** We cannot offer cancellation. */
  None = 'NONE'
}

export type FlowClaimAudioRecordingInput = {
  audioUrl?: InputMaybe<Scalars['Url']['input']>;
  freeText?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimAutomaticAutogiroPayoutInput = {
  amount: Scalars['Float']['input'];
};

export type FlowClaimConfirmEmergencyInput = {
  confirmEmergency: Scalars['Boolean']['input'];
};

export type FlowClaimContractSelectInput = {
  contractId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FlowClaimDateOfOccurrenceInput = {
  dateOfOccurrence?: InputMaybe<Scalars['Date']['input']>;
};

export type FlowClaimDateOfOccurrencePlusLocationInput = {
  dateOfOccurrence?: InputMaybe<Scalars['Date']['input']>;
  location?: InputMaybe<Scalars['ID']['input']>;
  subLocation?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimFileUploadInput = {
  fileIds: Array<Scalars['ID']['input']>;
};

export type FlowClaimInfoStepInput = {
  values: Array<FlowClaimInfoValueInput>;
};

export type FlowClaimInfoValueInput = {
  arrayValue?: InputMaybe<Array<Scalars['String']['input']>>;
  booleanValue?: InputMaybe<Scalars['Boolean']['input']>;
  dateValue?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  integerValue?: InputMaybe<Scalars['Int']['input']>;
  stringValue?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimItemBrandInput = {
  itemBrandId: Scalars['ID']['input'];
  itemTypeId: Scalars['ID']['input'];
};

export type FlowClaimItemModelInput = {
  itemModelId: Scalars['UUID']['input'];
};

export type FlowClaimLocationInput = {
  location?: InputMaybe<Scalars['ID']['input']>;
  subLocation?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimPersonSelectInput = {
  selected: Array<FlowClaimPersonSelectedInput>;
};

export type FlowClaimPersonSelectedInput = {
  fullName: Scalars['String']['input'];
  isHolder: Scalars['Boolean']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type FlowClaimPhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type FlowClaimSingleItemCheckoutInput = {
  automaticAutogiro?: InputMaybe<FlowClaimAutomaticAutogiroPayoutInput>;
};

export type FlowClaimSingleItemInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  itemBrandInput?: InputMaybe<FlowClaimItemBrandInput>;
  itemModelInput?: InputMaybe<FlowClaimItemModelInput>;
  itemProblemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FlowClaimStartInput = {
  entrypointId?: InputMaybe<Scalars['ID']['input']>;
  entrypointOptionId?: InputMaybe<Scalars['ID']['input']>;
  supportedSteps?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type FlowClaimSummaryInput = {
  customName?: InputMaybe<Scalars['String']['input']>;
  dateOfOccurrence?: InputMaybe<Scalars['Date']['input']>;
  itemBrandInput?: InputMaybe<FlowClaimItemBrandInput>;
  itemModelInput?: InputMaybe<FlowClaimItemModelInput>;
  itemProblemIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  location?: InputMaybe<Scalars['ID']['input']>;
  purchaseDate?: InputMaybe<Scalars['Date']['input']>;
  purchasePrice?: InputMaybe<Scalars['Float']['input']>;
};

export type FlowTerminationDateInput = {
  terminationDate: Scalars['Date']['input'];
};

export type FlowTerminationDeletionInput = {
  /** This has no significance and is ignored by the backend. It exists to satisfy some codegen limitations */
  confirmed: Scalars['Boolean']['input'];
};

export type FlowTerminationStartInput = {
  contractId: Scalars['ID']['input'];
};

export type FlowTerminationSurveyDataInput = {
  optionId: Scalars['ID']['input'];
  /** User submitted text feedback, if any */
  text?: InputMaybe<Scalars['String']['input']>;
};

export type FlowTerminationSurveyInput = {
  data: FlowTerminationSurveyDataInput;
};

/**
 * Decides how the suggestion should be presented to the user.
 * Corresponds to a color mapping in the apps.
 */
export enum FlowTerminationSurveyOptionSuggestionInfoType {
  Info = 'INFO',
  Offer = 'OFFER'
}

export enum FlowTerminationSurveyRedirectAction {
  ChangeTierFoundBetterPrice = 'CHANGE_TIER_FOUND_BETTER_PRICE',
  ChangeTierMissingCoverageAndTerms = 'CHANGE_TIER_MISSING_COVERAGE_AND_TERMS',
  UpdateAddress = 'UPDATE_ADDRESS'
}

export enum HedvigColor {
  Black = 'Black',
  BlackPurple = 'BlackPurple',
  DarkGray = 'DarkGray',
  DarkPurple = 'DarkPurple',
  LightGray = 'LightGray',
  OffBlack = 'OffBlack',
  OffWhite = 'OffWhite',
  Pink = 'Pink',
  Purple = 'Purple',
  Turquoise = 'Turquoise',
  White = 'White',
  Yellow = 'Yellow'
}

export enum InsurableLimitType {
  Bike = 'BIKE',
  Deductible = 'DEDUCTIBLE',
  DeductibleAllRisk = 'DEDUCTIBLE_ALL_RISK',
  DeductibleNatureDamage = 'DEDUCTIBLE_NATURE_DAMAGE',
  DentalTreatment = 'DENTAL_TREATMENT',
  GoodsFamily = 'GOODS_FAMILY',
  GoodsIndividual = 'GOODS_INDIVIDUAL',
  InsuredAmount = 'INSURED_AMOUNT',
  LostLuggage = 'LOST_LUGGAGE',
  MedicalExpenses = 'MEDICAL_EXPENSES',
  PermanentInjury = 'PERMANENT_INJURY',
  TravelCancellation = 'TRAVEL_CANCELLATION',
  TravelDays = 'TRAVEL_DAYS',
  TravelDelayedLuggage = 'TRAVEL_DELAYED_LUGGAGE',
  TravelDelayedOnTrip = 'TRAVEL_DELAYED_ON_TRIP',
  TravelIllnessInjuryTransportationHome = 'TRAVEL_ILLNESS_INJURY_TRANSPORTATION_HOME',
  Treatment = 'TREATMENT'
}

export enum InsuranceDocumentType {
  GeneralTerms = 'GENERAL_TERMS',
  PreSaleInfo = 'PRE_SALE_INFO',
  PreSaleInfoEuStandard = 'PRE_SALE_INFO_EU_STANDARD',
  PrivacyPolicy = 'PRIVACY_POLICY',
  ScarTable = 'SCAR_TABLE',
  TermsAndConditions = 'TERMS_AND_CONDITIONS'
}

export type InsuranceEvidenceInput = {
  email: Scalars['String']['input'];
};

export type InsurelyInitiateIframeDataCollectionInput = {
  collectionId: Scalars['String']['input'];
  partner?: InputMaybe<Scalars['String']['input']>;
};

/** The status of the charge */
export enum MemberChargeStatus {
  /** The charge failed */
  Failed = 'FAILED',
  /** The charge is pending that means either has been send to payment-service or to the payment provider */
  Pending = 'PENDING',
  /** The charge was settled successfully */
  Success = 'SUCCESS',
  /** A charge that is upcoming */
  Upcoming = 'UPCOMING'
}

/** Input for `Mutation.memberDeviceRegister` */
export type MemberDeviceRegisterInput = {
  /** The platform this token is connected to. */
  platform: AppPlatform;
  /** The token to register. */
  token: Scalars['String']['input'];
};

export enum MemberPaymentConnectionStatus {
  /** The payment connection is good to go. */
  Active = 'ACTIVE',
  /** There is no payment connection. */
  NeedsSetup = 'NEEDS_SETUP',
  /** The payment connection has been partially set up but is awaiting activation. */
  Pending = 'PENDING'
}

export enum MemberReferralStatus {
  Active = 'ACTIVE',
  Pending = 'PENDING',
  Terminated = 'TERMINATED'
}

/** Input for memberUpdateContactInfo mutation. */
export type MemberUpdateContactInfoInput = {
  email: Scalars['String']['input'];
  phoneNumber: Scalars['String']['input'];
};

export type MemberUpdateEmailInput = {
  email: Scalars['String']['input'];
};

export type MemberUpdateEurobonusNumberInput = {
  eurobonusNumber: Scalars['String']['input'];
};

export type MemberUpdateLanguageInput = {
  ietfLanguageTag: Scalars['String']['input'];
};

export type MemberUpdatePhoneNumberInput = {
  phoneNumber: Scalars['String']['input'];
};

export type MidtermChangeIntentCreateInput = {
  /**
   * The list of all co-insured to set on the agreement, i.e. size equals nbrOfCoInsured.
   * This list contains "null" entries for co-insured not yet defined.
   */
  coInsuredInputs?: InputMaybe<Array<CoInsuredInput>>;
};

export enum MidtermChangeIntentState {
  Completed = 'COMPLETED',
  Initiated = 'INITIATED'
}

export enum MoveApartmentSubType {
  Own = 'OWN',
  Rent = 'RENT'
}

export enum MoveApiVersion {
  V1 = 'V1',
  V2TiersAndDeductibles = 'V2_TIERS_AND_DEDUCTIBLES'
}

export type MoveExtraBuildingInput = {
  /**  Area of extra building  */
  area: Scalars['Int']['input'];
  /**  If extra building has water connected  */
  hasWaterConnected: Scalars['Boolean']['input'];
  /**  Extra building type  */
  type: MoveExtraBuildingType;
};

export enum MoveExtraBuildingType {
  Attefall = 'ATTEFALL',
  Barn = 'BARN',
  Boathouse = 'BOATHOUSE',
  Carport = 'CARPORT',
  Friggebod = 'FRIGGEBOD',
  Garage = 'GARAGE',
  Gazebo = 'GAZEBO',
  Greenhouse = 'GREENHOUSE',
  Guesthouse = 'GUESTHOUSE',
  Other = 'OTHER',
  Outhouse = 'OUTHOUSE',
  Sauna = 'SAUNA',
  Shed = 'SHED',
  Storehouse = 'STOREHOUSE'
}

export type MoveIntentRequestInput = {
  /**  Data if to move to an apartment  */
  apartment?: InputMaybe<MoveToApartmentInput>;
  /**  The version of this API used by the client  */
  apiVersion?: InputMaybe<MoveApiVersion>;
  /**  Data if to move to house  */
  house?: InputMaybe<MoveToHouseInput>;
  /**  This is the ID you get in MoveIntent:currentHomeAddresses member selected to move from  */
  moveFromAddressId: Scalars['ID']['input'];
  /**  The new address to move to  */
  moveToAddress: MoveToAddressInput;
  /**  The moving date new insurance should be activated  */
  movingDate: Scalars['Date']['input'];
  /**  The number of co-insured on new address  */
  numberCoInsured: Scalars['Int']['input'];
  /**  The number of square meters of new home  */
  squareMeters: Scalars['Int']['input'];
};

export type MoveToAddressInput = {
  /**  The city to move to  */
  city?: InputMaybe<Scalars['String']['input']>;
  /**  The postal code to move to  */
  postalCode: Scalars['String']['input'];
  /**  The street to move to  */
  street: Scalars['String']['input'];
};

export type MoveToApartmentInput = {
  /**  If member is student  */
  isStudent: Scalars['Boolean']['input'];
  /**  The subtype of new apartment  */
  subType: MoveApartmentSubType;
};

export type MoveToHouseInput = {
  /**  The ancillary area of new house  */
  ancillaryArea: Scalars['Int']['input'];
  /**  Extra buildings for new house  */
  extraBuildings: Array<MoveExtraBuildingInput>;
  /**  If new house is subleted  */
  isSubleted: Scalars['Boolean']['input'];
  /**  Number of bathrooms in new house  */
  numberOfBathrooms: Scalars['Int']['input'];
  /**  The year of construction of new house  */
  yearOfConstruction: Scalars['Int']['input'];
};

export type PartnerWidgetInitInput = {
  countryCode: CountryCode;
  externalMemberId?: InputMaybe<Scalars['UUID']['input']>;
  externalRequestId?: InputMaybe<Scalars['String']['input']>;
  partnerId: Scalars['UUID']['input'];
};

export type PersonalInformationInput = {
  personalNumber: Scalars['String']['input'];
};

export enum PriceIntentAnimal {
  Cat = 'CAT',
  Dog = 'DOG'
}

export type PriceIntentCreateInput = {
  /** The human readable, logical name that identifies the product. I.e. `SE_APARTMENT_BRF` or similar. */
  productName: Scalars['String']['input'];
  shopSessionId: Scalars['UUID']['input'];
};

export type PriceIntentFilters = {
  uniqueConfirmed?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum PriceIntentNotificationType {
  Info = 'INFO',
  Notice = 'NOTICE',
  Warning = 'WARNING'
}

export enum RedeemedCampaignType {
  /** Invited by a friend (Hedvig Forever) */
  Referral = 'REFERRAL',
  /** Some kind of discount usually created in Hope. */
  Voucher = 'VOUCHER'
}

export type RegisterDirectDebitClientContext2 = {
  failureUrl: Scalars['String']['input'];
  successUrl: Scalars['String']['input'];
};

export type ShopSessionCartCampaignRedeemInput = {
  code: Scalars['String']['input'];
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCartCampaignUnredeemInput = {
  campaignId: Scalars['String']['input'];
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCartEntriesAddInput = {
  offerIds: Array<Scalars['UUID']['input']>;
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCartEntriesRemoveInput = {
  offerIds: Array<Scalars['UUID']['input']>;
  shopSessionId: Scalars['UUID']['input'];
};

export type ShopSessionCreateInput = {
  attributedTo?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryCode;
  initiatedFrom?: InputMaybe<Scalars['String']['input']>;
};

export type ShopSessionCreatePartnerInput = {
  /** Optional campaign code if partner configuration support this */
  campaignCode?: InputMaybe<Scalars['String']['input']>;
  countryCode: CountryCode;
  /** Used for matching trial data with earlier trial created via backed API */
  externalMemberId?: InputMaybe<Scalars['String']['input']>;
  initiatedFrom?: InputMaybe<Scalars['String']['input']>;
  /** Known partner name, case-insensitive */
  partnerName: Scalars['String']['input'];
  /** Will be used for webhooks if provided. Otherwise random UUID will be generated */
  partnerRequestId?: InputMaybe<Scalars['String']['input']>;
};

export enum ShopSessionCustomerMissingField {
  Email = 'EMAIL',
  FirstName = 'FIRST_NAME',
  LastName = 'LAST_NAME',
  PhoneNumber = 'PHONE_NUMBER'
}

export type ShopSessionCustomerUpdateInput = {
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  shopSessionId: Scalars['UUID']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export enum ShopSessionSigningStatus {
  /**
   * This state indicates that the signing is accepted, but is actively being rolled out through the system.
   * The front-end can use this value to display progress feedback to the user if wanted.
   */
  Creating = 'CREATING',
  /** The signing failed for some reason. Could be that it was cancelled by the user or something else. */
  Failed = 'FAILED',
  /** Signing still in-process, and is awaiting action from the user, such as using an external BankID service. */
  Pending = 'PENDING',
  /** This means the signing has completed successfully. */
  Signed = 'SIGNED'
}

export type SubmitAdyenRedirectionRequest = {
  md: Scalars['String']['input'];
  pares: Scalars['String']['input'];
};

export enum TokenizationChannel {
  Android = 'ANDROID',
  Ios = 'IOS',
  Web = 'WEB'
}

export type TokenizationRequest = {
  browserInfo?: InputMaybe<BrowserInfo>;
  channel: TokenizationChannel;
  paymentMethodDetails: Scalars['PaymentMethodDetails']['input'];
  returnUrl: Scalars['String']['input'];
};

export enum TokenizationResultType {
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type TravelCertificateCreateCoInsured = {
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  fullName: Scalars['String']['input'];
  ssn?: InputMaybe<Scalars['String']['input']>;
};

export type TravelCertificateCreateInput = {
  coInsured: Array<TravelCertificateCreateCoInsured>;
  contractId: Scalars['String']['input'];
  email: Scalars['String']['input'];
  endDate?: InputMaybe<Scalars['Date']['input']>;
  isMemberIncluded: Scalars['Boolean']['input'];
  startDate: Scalars['Date']['input'];
};

/** Type of flow, upsell or upgrade addon. */
export enum UpsellTravelAddonFlow {
  AppOnlyUpsale = 'APP_ONLY_UPSALE',
  AppUpsellUpgrade = 'APP_UPSELL_UPGRADE'
}

export enum Join__Graph {
  AccountService = 'ACCOUNT_SERVICE',
  BotService = 'BOT_SERVICE',
  ClaimsService = 'CLAIMS_SERVICE',
  LookupService = 'LOOKUP_SERVICE',
  MemberService = 'MEMBER_SERVICE',
  NotificationService = 'NOTIFICATION_SERVICE',
  Odyssey = 'ODYSSEY',
  PaymentService = 'PAYMENT_SERVICE',
  ProductPricing = 'PRODUCT_PRICING',
  Storefront = 'STOREFRONT',
  TermsHub = 'TERMS_HUB',
  Underwriter = 'UNDERWRITER'
}

export enum Link__Purpose {
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION',
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY'
}

export type SwitcherCaseCompleteMutationVariables = Exact<{
  id: Scalars['UUID']['input'];
  currentExpiryDate: Scalars['Date']['input'];
}>;


export type SwitcherCaseCompleteMutation = { __typename?: 'Mutation', switcherCaseComplete: { __typename?: 'SwitcherCaseMutationOutput', switcherCase?: { __typename?: 'SwitcherCase', id: string, isCompleted: boolean } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type SwitcherCaseQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type SwitcherCaseQuery = { __typename?: 'Query', switcherCase: { __typename?: 'SwitcherCase', id: string, isCompleted: boolean } };

export type TierComparisonQueryVariables = Exact<{
  termsVersions: Array<Scalars['ID']['input']> | Scalars['ID']['input'];
}>;


export type TierComparisonQuery = { __typename?: 'Query', productVariantComparison: { __typename?: 'ProductVariantComparison', variantColumns: Array<{ __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayNameTier?: string | null, displayNameSubtype: string, perils: Array<{ __typename?: 'Peril', colorCode?: string | null, covered: Array<string> }> }>, rows: Array<{ __typename?: 'ProductVariantComparisonRow', title: string, description: string, cells: Array<{ __typename?: 'ProductVariantComparisonCell', isCovered: boolean, coverageText?: string | null }> }> } };

export type ProductVariantFragment = { __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayName: string, displayNameSubtype: string, tierDescription?: string | null, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> };

export type ProductDataFullFragment = { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string }, variants: Array<{ __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayName: string, displayNameSubtype: string, tierDescription?: string | null, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> }> };

export type ProductDataQueryVariables = Exact<{
  productName: Scalars['String']['input'];
  partnerName?: InputMaybe<Scalars['String']['input']>;
}>;


export type ProductDataQuery = { __typename?: 'Query', product?: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string }, variants: Array<{ __typename?: 'ProductVariant', typeOfContract: string, termsVersion: string, displayName: string, displayNameSubtype: string, tierDescription?: string | null, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> }> } | null };

export type ProductRecommendationsQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ProductRecommendationsQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, recommendations: Array<{ __typename?: 'ProductRecommendation', product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null }, offer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, displayTitle: string, displayValue: string }>, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string }, variant: { __typename?: 'ProductVariant', typeOfContract: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> } | null }> } };

export type ProductRecommendationFragment = { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null };

export type OfferRecommendationFragment = { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, displayTitle: string, displayValue: string }>, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string }, variant: { __typename?: 'ProductVariant', typeOfContract: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> };

export type RecommendationFragment = { __typename?: 'ProductRecommendation', product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null }, featuredImage?: { __typename?: 'StoryblokImageAsset', id: string, src: string, alt?: string | null } | null }, offer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentData: any, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, displayTitle: string, displayValue: string }>, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string }, variant: { __typename?: 'ProductVariant', typeOfContract: string, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> } | null };

export type AddonComparisonQueryVariables = Exact<{
  baseTermsVersion: Scalars['ID']['input'];
  addonTermsVersion: Scalars['ID']['input'];
}>;


export type AddonComparisonQuery = { __typename?: 'Query', addonComparison: { __typename?: 'AddonComparison', addonVariant: { __typename?: 'AddonVariant', termsVersion: string, displayName: string }, rows: Array<{ __typename?: 'AddonComparisonRow', title: string, description: string, cells: Array<{ __typename?: 'AddonComparisonCell', isCovered: boolean, coverageText?: string | null }> }> } };

export type AddonComparisonFragment = { __typename?: 'AddonComparison', addonVariant: { __typename?: 'AddonVariant', termsVersion: string, displayName: string }, rows: Array<{ __typename?: 'AddonComparisonRow', title: string, description: string, cells: Array<{ __typename?: 'AddonComparisonCell', isCovered: boolean, coverageText?: string | null }> }> };

export type CarDealershipRemoveAddMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  removeOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  addOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CarDealershipRemoveAddMutation = { __typename?: 'Mutation', shopSessionCartEntriesRemove: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', cart: { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string } }> } } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', cart: { __typename?: 'Cart', items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string } }> } } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CarTrialExtensionQueryVariables = Exact<{
  contractId: Scalars['UUID']['input'];
}>;


export type CarTrialExtensionQuery = { __typename?: 'Query', carTrial?: { __typename?: 'TrialExtension', id: string, collectConsent: boolean, consentGiven: boolean, priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', src: string } }, defaultOffer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> } | null }, shopSession: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null }, trialContract: { __typename?: 'TrialContract', id: string, exposureDisplayName: string, terminationDate?: any | null, activeFrom: any, activeTo?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> } } } | null };

export type PriceIntentCarTrialExtensionFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, product: { __typename?: 'Product', id: string, name: string, displayNameShort: string, pageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', src: string } }, defaultOffer?: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> } | null };

export type PriceIntentDataUpdateCarMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  data: Scalars['PricingFormData']['input'];
}>;


export type PriceIntentDataUpdateCarMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type TrialContractFragment = { __typename?: 'TrialContract', id: string, exposureDisplayName: string, terminationDate?: any | null, activeFrom: any, activeTo?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }> } };

export type MemberAreaMemberInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type MemberAreaMemberInfoQuery = { __typename?: 'Query', currentMember: { __typename?: 'Member', firstName: string, lastName: string, email: string, ssn?: string | null, activeContracts: Array<{ __typename?: 'Contract', id: string, exposureDisplayName: string, currentAgreement: { __typename?: 'Agreement', activeFrom: any, activeTo: any, certificateUrl?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, typeOfContract: string, termsVersion: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string }>, perils: Array<{ __typename?: 'Peril', colorCode?: string | null, covered: Array<string>, description: string, exceptions: Array<string>, title: string }> } } }>, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus, connection?: { __typename?: 'MemberPaymentConnection', descriptor: string, displayName: string } | null }, insuranceCost: { __typename?: 'MemberInsuranceCost', freeUntil?: any | null, monthlyDiscount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyNet: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } };

export type MemberContractFragment = { __typename?: 'Contract', id: string, exposureDisplayName: string, currentAgreement: { __typename?: 'Agreement', activeFrom: any, activeTo: any, certificateUrl?: any | null, displayItems: Array<{ __typename?: 'AgreementDisplayItem', displayTitle: string, displayValue: string }>, premium: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, productVariant: { __typename?: 'ProductVariant', displayName: string, typeOfContract: string, termsVersion: string, documents: Array<{ __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string }>, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string }>, perils: Array<{ __typename?: 'Peril', colorCode?: string | null, covered: Array<string>, description: string, exceptions: Array<string>, title: string }> } } };

export type MemberInsuranceCostFragment = { __typename?: 'MemberInsuranceCost', freeUntil?: any | null, monthlyDiscount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, monthlyNet: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } };

export type TravelCertificateCreateMutationVariables = Exact<{
  input: TravelCertificateCreateInput;
}>;


export type TravelCertificateCreateMutation = { __typename?: 'Mutation', travelCertificateCreate: { __typename?: 'TravelCertificate', id: string, signedUrl: any } };

export type CartEntriesAddMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  offerIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type CartEntriesAddMutation = { __typename?: 'Mutation', shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ShopSessionRetargetingQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionRetargetingQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, cart: { __typename?: 'Cart', campaignsEnabled: boolean, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string } }> }, priceIntents: Array<{ __typename?: 'PriceIntent', id: string, data: any, defaultOffer?: { __typename?: 'ProductOffer', id: string, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number } } } | null, product: { __typename?: 'Product', name: string } }> } };

export type RetargetingPriceIntentFragment = { __typename?: 'PriceIntent', id: string, data: any, defaultOffer?: { __typename?: 'ProductOffer', id: string, cost: { __typename?: 'ProductOfferCost', gross: { __typename?: 'Money', amount: number } } } | null, product: { __typename?: 'Product', name: string } };

export type WidgetPriceIntentQueryVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
}>;


export type WidgetPriceIntentQuery = { __typename?: 'Query', priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, product: { __typename?: 'Product', displayNameShort: string, id: string, name: string, displayNameFull: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', src: string, alt?: string | null } }, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } };

export type WidgetPriceIntentFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, product: { __typename?: 'Product', displayNameShort: string, id: string, name: string, displayNameFull: string, pageLink: string, priceCalculatorPageLink: string, pillowImage: { __typename?: 'StoryblokImageAsset', src: string, alt?: string | null } }, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null };

export type CartEntryAddMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type CartEntryAddMutation = { __typename?: 'Mutation', shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CartEntryRemoveMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  offerId: Scalars['UUID']['input'];
}>;


export type CartEntryRemoveMutation = { __typename?: 'Mutation', shopSessionCartEntriesRemove: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CartEntryReplaceMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  removeOfferId: Scalars['UUID']['input'];
  addOfferId: Scalars['UUID']['input'];
}>;


export type CartEntryReplaceMutation = { __typename?: 'Mutation', shopSessionCartEntriesRemove: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, shopSessionCartEntriesAdd: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type CartFragment = { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> };

export type CartCostFragment = { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } };

export type RedeemedCampaignFragment = { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } };

export type CampaignDiscountFragment = { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } };

export type RedeemCampaignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  code: Scalars['String']['input'];
}>;


export type RedeemCampaignMutation = { __typename?: 'Mutation', shopSessionCartCampaignRedeem: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type UnredeemCampaignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  campaignId: Scalars['String']['input'];
}>;


export type UnredeemCampaignMutation = { __typename?: 'Mutation', shopSessionCartCampaignUnredeem: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ContractQueryVariables = Exact<{
  id: Scalars['UUID']['input'];
}>;


export type ContractQuery = { __typename?: 'Query', contract: { __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } } } };

export type CurrentMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentMemberQuery = { __typename?: 'Query', currentMember: { __typename?: 'Member', id: string, email: string, firstName: string, lastName: string, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus }, partnerData?: { __typename?: 'PartnerData', sas?: { __typename?: 'SasPartnerData', eligible: boolean, eurobonusNumber?: string | null } | null } | null } };

export type ExternalInsurerUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  externalInsurerId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type ExternalInsurerUpdateMutation = { __typename?: 'Mutation', priceIntentExternalInsurerUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ExternalInsurersQueryVariables = Exact<{
  productName: Scalars['String']['input'];
}>;


export type ExternalInsurersQuery = { __typename?: 'Query', product?: { __typename?: 'Product', externalInsurers: Array<{ __typename?: 'ExternalInsurer', id: string, displayName: string }> } | null };

export type InsurableLimitFragment = { __typename?: 'InsurableLimit', label: string, limit: string, description: string };

export type InsuranceDocumentFragment = { __typename?: 'InsuranceDocument', displayName: string, type: InsuranceDocumentType, url: string };

export type InsurelyDataCollectionCreateMutationVariables = Exact<{
  collectionId: Scalars['String']['input'];
  partner: Scalars['String']['input'];
}>;


export type InsurelyDataCollectionCreateMutation = { __typename?: 'Mutation', insurelyInitiateIframeDataCollection: { __typename?: 'InsurelyInitiateIframeDataCollectionOutput', dataCollectionId: string } };

export type MemberFragment = { __typename?: 'Member', id: string, email: string, firstName: string, lastName: string, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus }, partnerData?: { __typename?: 'PartnerData', sas?: { __typename?: 'SasPartnerData', eligible: boolean, eurobonusNumber?: string | null } | null } | null };

export type OfferAddonSelectMutationVariables = Exact<{
  productOfferId: Scalars['UUID']['input'];
  addonIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
}>;


export type OfferAddonSelectMutation = { __typename?: 'Mutation', productOfferAddonsSelect: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }> } };

export type PerilFragment = { __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null };

export type PriceIntentQueryVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
}>;


export type PriceIntentQuery = { __typename?: 'Query', priceIntent: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } };

export type PriceIntentAvailableBreedsQueryVariables = Exact<{
  animal: PriceIntentAnimal;
}>;


export type PriceIntentAvailableBreedsQuery = { __typename?: 'Query', priceIntentAvailableBreeds: Array<{ __typename?: 'PriceIntentAnimalBreed', id: string, displayName: string, isMixedBreed: boolean }> };

export type PriceIntentAnimalBreedFragment = { __typename?: 'PriceIntentAnimalBreed', id: string, displayName: string, isMixedBreed: boolean };

export type CancellationRequestedUpdateMutationVariables = Exact<{
  productOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  requested: Scalars['Boolean']['input'];
}>;


export type CancellationRequestedUpdateMutation = { __typename?: 'Mutation', productOffersCancellationRequestedUpdate: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentConfirmMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
}>;


export type PriceIntentConfirmMutation = { __typename?: 'Mutation', priceIntentConfirm: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentCreateMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
  productName: Scalars['String']['input'];
}>;


export type PriceIntentCreateMutation = { __typename?: 'Mutation', priceIntentCreate: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } };

export type PriceIntentDataUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  data: Scalars['PricingFormData']['input'];
  customer: ShopSessionCustomerUpdateInput;
}>;


export type PriceIntentDataUpdateMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, shopSessionCustomerUpdate: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentFragment = { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null };

export type ExternalInsurerFragment = { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null };

export type PriceIntentInsurelyUpdateMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  dataCollectionId?: InputMaybe<Scalars['String']['input']>;
}>;


export type PriceIntentInsurelyUpdateMutation = { __typename?: 'Mutation', priceIntentInsurelyUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type PriceIntentUpdateAndConfirmMutationVariables = Exact<{
  priceIntentId: Scalars['UUID']['input'];
  data: Scalars['PricingFormData']['input'];
}>;


export type PriceIntentUpdateAndConfirmMutation = { __typename?: 'Mutation', priceIntentDataUpdate: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any } | null, userError?: { __typename?: 'UserError', message?: string | null } | null }, priceIntentConfirm: { __typename?: 'PriceIntentMutationOutput', priceIntent?: { __typename?: 'PriceIntent', id: string, data: any, suggestedData: any, minStartDate?: any | null, hasCollectedInsurelyData: boolean, offers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, defaultOffer?: { __typename?: 'ProductOffer', id: string } | null, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string, insurelyId?: string | null } | null, product: { __typename?: 'Product', id: string, name: string, displayNameFull: string, displayNameShort: string, pageLink: string, priceCalculatorPageLink: string }, insurely?: { __typename?: 'PriceIntentInsurely', configName: string, partner: string } | null, notifications?: Array<{ __typename?: 'PriceIntentNotification', message: string, type: PriceIntentNotificationType }> | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ProductMetadataQueryVariables = Exact<{ [key: string]: never; }>;


export type ProductMetadataQuery = { __typename?: 'Query', availableProducts: Array<{ __typename?: 'Product', id: string, name: string, displayNameShort: string, displayNameFull: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, categoryPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }> };

export type ProductFragment = { __typename?: 'Product', id: string, name: string, displayNameShort: string, displayNameFull: string, tagline: string, pageLink: string, priceCalculatorPageLink: string, categoryPageLink?: string | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } };

export type ProductOfferAddonFragment = { __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } };

export type ProductOfferCostDiscountSourceFragment = { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number };

export type ProductOfferFragment = { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> };

export type SasEurobonusNumberUpdateMutationVariables = Exact<{
  value: Scalars['String']['input'];
}>;


export type SasEurobonusNumberUpdateMutation = { __typename?: 'Mutation', memberUpdateEurobonusNumber: { __typename?: 'MemberMutationOutput', member?: { __typename?: 'Member', id: string, email: string, firstName: string, lastName: string, paymentInformation: { __typename?: 'MemberPaymentInformation', status: MemberPaymentConnectionStatus }, partnerData?: { __typename?: 'PartnerData', sas?: { __typename?: 'SasPartnerData', eligible: boolean, eurobonusNumber?: string | null } | null } | null } | null } };

export type ShopSessionQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } };

export type ShopSessionCreateMutationVariables = Exact<{
  countryCode: CountryCode;
  attributedTo?: InputMaybe<Scalars['String']['input']>;
  initiatedFrom?: InputMaybe<Scalars['String']['input']>;
}>;


export type ShopSessionCreateMutation = { __typename?: 'Mutation', shopSessionCreate: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } };

export type ShopSessionCustomerFragment = { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null };

export type ShopSessionCustomerUpdateMutationVariables = Exact<{
  input: ShopSessionCustomerUpdateInput;
}>;


export type ShopSessionCustomerUpdateMutation = { __typename?: 'Mutation', shopSessionCustomerUpdate: { __typename?: 'ShopSessionMutationOutput', shopSession?: { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ShopSessionFragment = { __typename?: 'ShopSession', id: string, countryCode: CountryCode, currencyCode: CurrencyCode, customer?: { __typename?: 'ShopSessionCustomer', missingFields: Array<ShopSessionCustomerMissingField>, ssn?: string | null } | null, cart: { __typename?: 'Cart', id: string, campaignsEnabled: boolean, cost: { __typename?: 'CartCost', gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } }, redeemedCampaign?: { __typename?: 'RedeemedCampaign', id: string, code: string, discount: { __typename?: 'CampaignDiscount', type: CampaignDiscountType, percentage: number, months: number, amount: { __typename?: 'Money', currencyCode: CurrencyCode, amount: number } } } | null, items: Array<{ __typename?: 'CartItem', productOffer: { __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }, notifications: Array<{ __typename?: 'CarItemNotification', message: string }> }> }, experiments?: { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null } | null };

export type ShopSessionExperimentsFragment = { __typename?: 'ShopSessionExperiments', bundleDiscount?: boolean | null };

export type ShopSessionOutcomeQueryVariables = Exact<{
  shopSessionOutcomeId: Scalars['UUID']['input'];
}>;


export type ShopSessionOutcomeQuery = { __typename?: 'Query', shopSessionOutcome?: { __typename?: 'ShopSessionOutcome', id: string, createdContracts: Array<{ __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } } }> } | null };

export type ShopSessionOutcomeFragment = { __typename?: 'ShopSessionOutcome', id: string, createdContracts: Array<{ __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } } }> };

export type ShopSessionOutcomeIdQueryVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionOutcomeIdQuery = { __typename?: 'Query', shopSession: { __typename?: 'ShopSession', id: string, outcome?: { __typename?: 'ShopSessionOutcome', id: string } | null } };

export type ShopSessionSigningQueryVariables = Exact<{
  shopSessionSigningId: Scalars['UUID']['input'];
}>;


export type ShopSessionSigningQuery = { __typename?: 'Query', shopSessionSigning: { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, seBankidProperties?: { __typename?: 'ShopSessionSigningSeBankidProperties', autoStartToken: string, liveQrCodeData: string, bankidAppOpened: boolean } | null, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type ShopSessionSigningFragment = { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, seBankidProperties?: { __typename?: 'ShopSessionSigningSeBankidProperties', autoStartToken: string, liveQrCodeData: string, bankidAppOpened: boolean } | null, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null };

export type ShopSessionStartSignMutationVariables = Exact<{
  shopSessionId: Scalars['UUID']['input'];
}>;


export type ShopSessionStartSignMutation = { __typename?: 'Mutation', shopSessionStartSign: { __typename?: 'ShopSessionSigningMutationOutput', signing?: { __typename?: 'ShopSessionSigning', id: string, status: ShopSessionSigningStatus, seBankidProperties?: { __typename?: 'ShopSessionSigningSeBankidProperties', autoStartToken: string, liveQrCodeData: string, bankidAppOpened: boolean } | null, completion?: { __typename?: 'ShopSessionSigningCompletion', authorizationCode: string } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } | null, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type StartDateUpdateMutationVariables = Exact<{
  productOfferIds: Array<Scalars['UUID']['input']> | Scalars['UUID']['input'];
  startDate: Scalars['Date']['input'];
}>;


export type StartDateUpdateMutation = { __typename?: 'Mutation', productOffersStartDateUpdate: { __typename?: 'ProductOffersMutationOutput', productOffers: Array<{ __typename?: 'ProductOffer', id: string, startDate?: any | null, priceIntentId?: string | null, priceIntentData: any, usps: Array<string>, product: { __typename?: 'Product', id: string, name: string, pageLink: string, priceCalculatorPageLink: string, displayNameShort: string, displayNameFull: string, categoryDisplayNameShort?: string | null, multiple?: boolean | null, pillowImage: { __typename?: 'StoryblokImageAsset', id: string, alt?: string | null, src: string } }, variant: { __typename?: 'ProductVariant', termsVersion: string, typeOfContract: string, displayName: string, displayNameSubtype: string, displayNameTier?: string | null, tierDescription?: string | null, insurableLimits: Array<{ __typename?: 'InsurableLimit', label: string, limit: string, description: string }>, perils: Array<{ __typename?: 'Peril', title: string, description: string, covered: Array<string>, exceptions: Array<string>, colorCode?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }> }, cost: { __typename?: 'ProductOfferCost', baseInsuranceGross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, gross: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, net: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discount: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, discountSource?: { __typename?: 'ProductOfferCostDiscountSource', campaignCode: string, discountPercent: number, durationMonths: number } | null }, cancellation: { __typename?: 'ExternalInsuranceCancellation', option: ExternalInsuranceCancellationOption, requested: boolean, externalInsurer?: { __typename?: 'ExternalInsurer', id: string, displayName: string } | null }, priceMatch?: { __typename?: 'ProductOfferPriceMatch', externalInsurer: { __typename?: 'ExternalInsurer', id: string, displayName: string }, priceReduction: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, externalPrice: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode } } | null, deductible?: { __typename?: 'ProductOfferDeductible', displayName: string, tagline: string, amount: number } | null, displayItems: Array<{ __typename?: 'ProductOfferDisplayItem', key: string, value: any, displayTitle: string, displayValue: string }>, exposure: { __typename?: 'ProductOfferExposure', displayNameShort: string }, addons: Array<{ __typename?: 'ProductOfferAddon', id: string, coverageText: string, description: string, usps: Array<string>, isSelected: boolean, grossCost: { __typename?: 'Money', amount: number, currencyCode: CurrencyCode }, variant: { __typename?: 'AddonVariant', termsVersion: string, product: string, displayName: string, documents: Array<{ __typename?: 'InsuranceDocument', type: InsuranceDocumentType, displayName: string, url: string }>, perils: Array<{ __typename?: 'Peril', title: string }> } }> }>, userError?: { __typename?: 'UserError', message?: string | null } | null } };

export type SwitchingContractFragment = { __typename?: 'Contract', id: string, currentAgreement: { __typename?: 'Agreement', productVariant: { __typename?: 'ProductVariant', displayName: string, displayNameSubtype: string } } };

export type TrustlyInitMutationVariables = Exact<{
  successUrl: Scalars['String']['input'];
  failureUrl: Scalars['String']['input'];
}>;


export type TrustlyInitMutation = { __typename?: 'Mutation', registerDirectDebit2: { __typename?: 'DirectDebitResponse2', url: string, orderId: string } };

export type UserErrorFragment = { __typename?: 'UserError', message?: string | null };

export type SendEventBatchMutationVariables = Exact<{
  inputList: Array<EventInput> | EventInput;
}>;


export type SendEventBatchMutation = { __typename?: 'Mutation', sendEventBatch: Array<string> };

export const PerilFragmentDoc = gql`
    fragment Peril on Peril {
  title
  description
  covered
  exceptions
  colorCode
}
    `;
export const InsuranceDocumentFragmentDoc = gql`
    fragment InsuranceDocument on InsuranceDocument {
  displayName
  type
  url
}
    `;
export const ProductVariantFragmentDoc = gql`
    fragment ProductVariant on ProductVariant {
  typeOfContract
  termsVersion
  displayName
  displayNameSubtype
  tierDescription
  perils {
    ...Peril
  }
  insurableLimits {
    label
    limit
    description
  }
  documents {
    ...InsuranceDocument
  }
}
    ${PerilFragmentDoc}
${InsuranceDocumentFragmentDoc}`;
export const ProductDataFullFragmentDoc = gql`
    fragment ProductDataFull on Product {
  id
  name
  displayNameFull
  displayNameShort
  tagline
  pageLink
  priceCalculatorPageLink
  pillowImage {
    id
    alt
    src
  }
  variants {
    ...ProductVariant
  }
}
    ${ProductVariantFragmentDoc}`;
export const ProductRecommendationFragmentDoc = gql`
    fragment ProductRecommendation on Product {
  id
  name
  displayNameFull
  displayNameShort
  tagline
  pageLink
  priceCalculatorPageLink
  pillowImage {
    id
    src
    alt
  }
  featuredImage {
    id
    src
    alt
  }
}
    `;
export const ProductOfferAddonFragmentDoc = gql`
    fragment ProductOfferAddon on ProductOfferAddon {
  id
  coverageText
  description
  usps
  grossCost {
    amount
    currencyCode
  }
  isSelected
  variant {
    termsVersion
    product
    displayName
    documents {
      type
      displayName
      url
    }
    perils {
      title
    }
  }
}
    `;
export const OfferRecommendationFragmentDoc = gql`
    fragment OfferRecommendation on ProductOffer {
  id
  startDate
  priceIntentData
  displayItems {
    key
    displayTitle
    displayValue
  }
  product {
    id
    name
    displayNameFull
  }
  variant {
    typeOfContract
    perils {
      ...Peril
    }
    insurableLimits {
      label
      limit
      description
    }
  }
  cost {
    baseInsuranceGross {
      amount
      currencyCode
    }
    gross {
      amount
      currencyCode
    }
    net {
      amount
      currencyCode
    }
    discount {
      amount
      currencyCode
    }
  }
  addons {
    ...ProductOfferAddon
  }
}
    ${PerilFragmentDoc}
${ProductOfferAddonFragmentDoc}`;
export const RecommendationFragmentDoc = gql`
    fragment Recommendation on ProductRecommendation {
  product {
    ...ProductRecommendation
  }
  offer {
    ...OfferRecommendation
  }
}
    ${ProductRecommendationFragmentDoc}
${OfferRecommendationFragmentDoc}`;
export const AddonComparisonFragmentDoc = gql`
    fragment AddonComparison on AddonComparison {
  addonVariant {
    termsVersion
    displayName
  }
  rows {
    title
    description
    cells {
      isCovered
      coverageText
    }
  }
}
    `;
export const InsurableLimitFragmentDoc = gql`
    fragment InsurableLimit on InsurableLimit {
  label
  limit
  description
}
    `;
export const ProductOfferCostDiscountSourceFragmentDoc = gql`
    fragment ProductOfferCostDiscountSource on ProductOfferCostDiscountSource {
  campaignCode
  discountPercent
  durationMonths
}
    `;
export const ProductOfferFragmentDoc = gql`
    fragment ProductOffer on ProductOffer {
  id
  product {
    id
    name
    pageLink
    priceCalculatorPageLink
    displayNameShort
    displayNameFull
    categoryDisplayNameShort
    multiple
    pillowImage {
      id
      alt
      src
    }
  }
  variant {
    termsVersion
    typeOfContract
    displayName
    displayNameSubtype
    displayNameTier
    tierDescription
    insurableLimits {
      ...InsurableLimit
    }
    perils {
      ...Peril
    }
    documents {
      type
      displayName
      url
    }
  }
  cost {
    baseInsuranceGross {
      amount
      currencyCode
    }
    gross {
      amount
      currencyCode
    }
    net {
      amount
      currencyCode
    }
    discount {
      amount
      currencyCode
    }
    discountSource {
      ...ProductOfferCostDiscountSource
    }
  }
  startDate
  cancellation {
    option
    requested
    externalInsurer {
      id
      displayName
    }
  }
  priceMatch {
    externalInsurer {
      id
      displayName
    }
    priceReduction {
      amount
      currencyCode
    }
    externalPrice {
      amount
      currencyCode
    }
  }
  priceIntentId
  priceIntentData
  deductible {
    displayName
    tagline
    amount
  }
  usps
  displayItems {
    key
    value
    displayTitle
    displayValue
  }
  exposure {
    displayNameShort
  }
  addons {
    ...ProductOfferAddon
  }
}
    ${InsurableLimitFragmentDoc}
${PerilFragmentDoc}
${ProductOfferCostDiscountSourceFragmentDoc}
${ProductOfferAddonFragmentDoc}`;
export const PriceIntentCarTrialExtensionFragmentDoc = gql`
    fragment PriceIntentCarTrialExtension on PriceIntent {
  id
  data
  suggestedData
  offers {
    ...ProductOffer
  }
  product {
    id
    name
    displayNameShort
    pageLink
    pillowImage {
      src
    }
  }
  defaultOffer {
    ...ProductOffer
  }
}
    ${ProductOfferFragmentDoc}`;
export const TrialContractFragmentDoc = gql`
    fragment TrialContract on TrialContract {
  id
  exposureDisplayName
  terminationDate
  activeFrom
  activeTo
  displayItems {
    displayTitle
    displayValue
  }
  premium {
    amount
    currencyCode
  }
  productVariant {
    displayName
    displayNameSubtype
    documents {
      displayName
      type
      url
    }
  }
}
    `;
export const MemberContractFragmentDoc = gql`
    fragment MemberContract on Contract {
  id
  currentAgreement {
    activeFrom
    activeTo
    certificateUrl
    displayItems {
      displayTitle
      displayValue
    }
    premium {
      amount
      currencyCode
    }
    productVariant {
      displayName
      typeOfContract
      termsVersion
      documents {
        ...InsuranceDocument
      }
      insurableLimits {
        label
        limit
      }
      perils {
        colorCode
        covered
        description
        exceptions
        title
      }
    }
  }
  exposureDisplayName
}
    ${InsuranceDocumentFragmentDoc}`;
export const MemberInsuranceCostFragmentDoc = gql`
    fragment MemberInsuranceCost on MemberInsuranceCost {
  freeUntil
  monthlyDiscount {
    amount
    currencyCode
  }
  monthlyGross {
    amount
    currencyCode
  }
  monthlyNet {
    currencyCode
    amount
  }
}
    `;
export const RetargetingPriceIntentFragmentDoc = gql`
    fragment RetargetingPriceIntent on PriceIntent {
  id
  data
  defaultOffer {
    id
    cost {
      gross {
        amount
      }
    }
  }
  product {
    name
  }
}
    `;
export const ExternalInsurerFragmentDoc = gql`
    fragment ExternalInsurer on ExternalInsurer {
  id
  displayName
  insurelyId
}
    `;
export const PriceIntentFragmentDoc = gql`
    fragment PriceIntent on PriceIntent {
  id
  data
  suggestedData
  minStartDate
  offers {
    ...ProductOffer
  }
  defaultOffer {
    id
  }
  externalInsurer {
    ...ExternalInsurer
  }
  product {
    id
    name
    displayNameFull
    displayNameShort
    pageLink
    priceCalculatorPageLink
  }
  insurely {
    configName
    partner
  }
  notifications {
    message
    type
  }
  hasCollectedInsurelyData
}
    ${ProductOfferFragmentDoc}
${ExternalInsurerFragmentDoc}`;
export const WidgetPriceIntentFragmentDoc = gql`
    fragment WidgetPriceIntent on PriceIntent {
  ...PriceIntent
  product {
    displayNameShort
    pillowImage {
      src
      alt
    }
  }
}
    ${PriceIntentFragmentDoc}`;
export const MemberFragmentDoc = gql`
    fragment Member on Member {
  id
  email
  firstName
  lastName
  paymentInformation {
    status
  }
  partnerData {
    sas {
      eligible
      eurobonusNumber
    }
  }
}
    `;
export const PriceIntentAnimalBreedFragmentDoc = gql`
    fragment PriceIntentAnimalBreed on PriceIntentAnimalBreed {
  id
  displayName
  isMixedBreed
}
    `;
export const ProductFragmentDoc = gql`
    fragment Product on Product {
  id
  name
  displayNameShort
  displayNameFull
  tagline
  pageLink
  priceCalculatorPageLink
  categoryPageLink
  pillowImage {
    id
    alt
    src
  }
}
    `;
export const ShopSessionCustomerFragmentDoc = gql`
    fragment ShopSessionCustomer on ShopSessionCustomer {
  missingFields
  ssn
}
    `;
export const CartCostFragmentDoc = gql`
    fragment CartCost on CartCost {
  gross {
    amount
    currencyCode
  }
  net {
    amount
    currencyCode
  }
  discount {
    amount
    currencyCode
  }
}
    `;
export const CampaignDiscountFragmentDoc = gql`
    fragment CampaignDiscount on CampaignDiscount {
  type
  amount {
    currencyCode
    amount
  }
  percentage
  months
}
    `;
export const RedeemedCampaignFragmentDoc = gql`
    fragment RedeemedCampaign on RedeemedCampaign {
  id
  code
  discount {
    ...CampaignDiscount
  }
}
    ${CampaignDiscountFragmentDoc}`;
export const CartFragmentDoc = gql`
    fragment Cart on Cart {
  id
  campaignsEnabled
  cost {
    ...CartCost
  }
  redeemedCampaign {
    ...RedeemedCampaign
  }
  items {
    productOffer {
      ...ProductOffer
    }
    notifications {
      message
    }
  }
}
    ${CartCostFragmentDoc}
${RedeemedCampaignFragmentDoc}
${ProductOfferFragmentDoc}`;
export const ShopSessionExperimentsFragmentDoc = gql`
    fragment ShopSessionExperiments on ShopSessionExperiments {
  bundleDiscount
}
    `;
export const ShopSessionFragmentDoc = gql`
    fragment ShopSession on ShopSession {
  id
  countryCode
  currencyCode
  customer {
    ...ShopSessionCustomer
  }
  cart {
    ...Cart
  }
  experiments {
    ...ShopSessionExperiments
  }
}
    ${ShopSessionCustomerFragmentDoc}
${CartFragmentDoc}
${ShopSessionExperimentsFragmentDoc}`;
export const SwitchingContractFragmentDoc = gql`
    fragment SwitchingContract on Contract {
  id
  currentAgreement {
    productVariant {
      displayName
      displayNameSubtype
    }
  }
}
    `;
export const ShopSessionOutcomeFragmentDoc = gql`
    fragment ShopSessionOutcome on ShopSessionOutcome {
  id
  createdContracts {
    ...SwitchingContract
  }
}
    ${SwitchingContractFragmentDoc}`;
export const ShopSessionSigningFragmentDoc = gql`
    fragment ShopSessionSigning on ShopSessionSigning {
  id
  status
  seBankidProperties {
    autoStartToken
    liveQrCodeData
    bankidAppOpened
  }
  completion {
    authorizationCode
  }
  userError {
    message
  }
}
    `;
export const UserErrorFragmentDoc = gql`
    fragment UserError on UserError {
  message
}
    `;
export const SwitcherCaseCompleteDocument = gql`
    mutation SwitcherCaseComplete($id: UUID!, $currentExpiryDate: Date!) {
  switcherCaseComplete(id: $id, currentExpiryDate: $currentExpiryDate) {
    switcherCase {
      id
      isCompleted
    }
    userError {
      ...UserError
    }
  }
}
    ${UserErrorFragmentDoc}`;
export type SwitcherCaseCompleteMutationFn = Apollo.MutationFunction<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>;

/**
 * __useSwitcherCaseCompleteMutation__
 *
 * To run a mutation, you first call `useSwitcherCaseCompleteMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSwitcherCaseCompleteMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [switcherCaseCompleteMutation, { data, loading, error }] = useSwitcherCaseCompleteMutation({
 *   variables: {
 *      id: // value for 'id'
 *      currentExpiryDate: // value for 'currentExpiryDate'
 *   },
 * });
 */
export function useSwitcherCaseCompleteMutation(baseOptions?: Apollo.MutationHookOptions<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>(SwitcherCaseCompleteDocument, options);
      }
export type SwitcherCaseCompleteMutationHookResult = ReturnType<typeof useSwitcherCaseCompleteMutation>;
export type SwitcherCaseCompleteMutationResult = Apollo.MutationResult<SwitcherCaseCompleteMutation>;
export type SwitcherCaseCompleteMutationOptions = Apollo.BaseMutationOptions<SwitcherCaseCompleteMutation, SwitcherCaseCompleteMutationVariables>;
export const SwitcherCaseDocument = gql`
    query SwitcherCase($id: UUID!) {
  switcherCase(id: $id) {
    id
    isCompleted
  }
}
    `;

/**
 * __useSwitcherCaseQuery__
 *
 * To run a query within a React component, call `useSwitcherCaseQuery` and pass it any options that fit your needs.
 * When your component renders, `useSwitcherCaseQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSwitcherCaseQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useSwitcherCaseQuery(baseOptions: Apollo.QueryHookOptions<SwitcherCaseQuery, SwitcherCaseQueryVariables> & ({ variables: SwitcherCaseQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SwitcherCaseQuery, SwitcherCaseQueryVariables>(SwitcherCaseDocument, options);
      }
export function useSwitcherCaseLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SwitcherCaseQuery, SwitcherCaseQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SwitcherCaseQuery, SwitcherCaseQueryVariables>(SwitcherCaseDocument, options);
        }
export function useSwitcherCaseSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<SwitcherCaseQuery, SwitcherCaseQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<SwitcherCaseQuery, SwitcherCaseQueryVariables>(SwitcherCaseDocument, options);
        }
export type SwitcherCaseQueryHookResult = ReturnType<typeof useSwitcherCaseQuery>;
export type SwitcherCaseLazyQueryHookResult = ReturnType<typeof useSwitcherCaseLazyQuery>;
export type SwitcherCaseSuspenseQueryHookResult = ReturnType<typeof useSwitcherCaseSuspenseQuery>;
export type SwitcherCaseQueryResult = Apollo.QueryResult<SwitcherCaseQuery, SwitcherCaseQueryVariables>;
export const TierComparisonDocument = gql`
    query TierComparison($termsVersions: [ID!]!) {
  productVariantComparison(termsVersions: $termsVersions) {
    variantColumns {
      typeOfContract
      termsVersion
      displayNameTier
      displayNameSubtype
      perils {
        colorCode
        covered
      }
    }
    rows {
      title
      description
      cells {
        isCovered
        coverageText
      }
    }
  }
}
    `;

/**
 * __useTierComparisonQuery__
 *
 * To run a query within a React component, call `useTierComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useTierComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTierComparisonQuery({
 *   variables: {
 *      termsVersions: // value for 'termsVersions'
 *   },
 * });
 */
export function useTierComparisonQuery(baseOptions: Apollo.QueryHookOptions<TierComparisonQuery, TierComparisonQueryVariables> & ({ variables: TierComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TierComparisonQuery, TierComparisonQueryVariables>(TierComparisonDocument, options);
      }
export function useTierComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TierComparisonQuery, TierComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TierComparisonQuery, TierComparisonQueryVariables>(TierComparisonDocument, options);
        }
export function useTierComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<TierComparisonQuery, TierComparisonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<TierComparisonQuery, TierComparisonQueryVariables>(TierComparisonDocument, options);
        }
export type TierComparisonQueryHookResult = ReturnType<typeof useTierComparisonQuery>;
export type TierComparisonLazyQueryHookResult = ReturnType<typeof useTierComparisonLazyQuery>;
export type TierComparisonSuspenseQueryHookResult = ReturnType<typeof useTierComparisonSuspenseQuery>;
export type TierComparisonQueryResult = Apollo.QueryResult<TierComparisonQuery, TierComparisonQueryVariables>;
export const ProductDataDocument = gql`
    query ProductData($productName: String!, $partnerName: String) {
  product(productName: $productName, partnerName: $partnerName) {
    ...ProductDataFull
  }
}
    ${ProductDataFullFragmentDoc}`;

/**
 * __useProductDataQuery__
 *
 * To run a query within a React component, call `useProductDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductDataQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *      partnerName: // value for 'partnerName'
 *   },
 * });
 */
export function useProductDataQuery(baseOptions: Apollo.QueryHookOptions<ProductDataQuery, ProductDataQueryVariables> & ({ variables: ProductDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
      }
export function useProductDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductDataQuery, ProductDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
        }
export function useProductDataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductDataQuery, ProductDataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductDataQuery, ProductDataQueryVariables>(ProductDataDocument, options);
        }
export type ProductDataQueryHookResult = ReturnType<typeof useProductDataQuery>;
export type ProductDataLazyQueryHookResult = ReturnType<typeof useProductDataLazyQuery>;
export type ProductDataSuspenseQueryHookResult = ReturnType<typeof useProductDataSuspenseQuery>;
export type ProductDataQueryResult = Apollo.QueryResult<ProductDataQuery, ProductDataQueryVariables>;
export const ProductRecommendationsDocument = gql`
    query ProductRecommendations($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    recommendations {
      ...Recommendation
    }
  }
}
    ${RecommendationFragmentDoc}`;

/**
 * __useProductRecommendationsQuery__
 *
 * To run a query within a React component, call `useProductRecommendationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductRecommendationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductRecommendationsQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useProductRecommendationsQuery(baseOptions: Apollo.QueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables> & ({ variables: ProductRecommendationsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
      }
export function useProductRecommendationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
        }
export function useProductRecommendationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>(ProductRecommendationsDocument, options);
        }
export type ProductRecommendationsQueryHookResult = ReturnType<typeof useProductRecommendationsQuery>;
export type ProductRecommendationsLazyQueryHookResult = ReturnType<typeof useProductRecommendationsLazyQuery>;
export type ProductRecommendationsSuspenseQueryHookResult = ReturnType<typeof useProductRecommendationsSuspenseQuery>;
export type ProductRecommendationsQueryResult = Apollo.QueryResult<ProductRecommendationsQuery, ProductRecommendationsQueryVariables>;
export const AddonComparisonDocument = gql`
    query AddonComparison($baseTermsVersion: ID!, $addonTermsVersion: ID!) {
  addonComparison(
    baseTermsVersion: $baseTermsVersion
    addonTermsVersion: $addonTermsVersion
  ) {
    ...AddonComparison
  }
}
    ${AddonComparisonFragmentDoc}`;

/**
 * __useAddonComparisonQuery__
 *
 * To run a query within a React component, call `useAddonComparisonQuery` and pass it any options that fit your needs.
 * When your component renders, `useAddonComparisonQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAddonComparisonQuery({
 *   variables: {
 *      baseTermsVersion: // value for 'baseTermsVersion'
 *      addonTermsVersion: // value for 'addonTermsVersion'
 *   },
 * });
 */
export function useAddonComparisonQuery(baseOptions: Apollo.QueryHookOptions<AddonComparisonQuery, AddonComparisonQueryVariables> & ({ variables: AddonComparisonQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<AddonComparisonQuery, AddonComparisonQueryVariables>(AddonComparisonDocument, options);
      }
export function useAddonComparisonLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<AddonComparisonQuery, AddonComparisonQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<AddonComparisonQuery, AddonComparisonQueryVariables>(AddonComparisonDocument, options);
        }
export function useAddonComparisonSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<AddonComparisonQuery, AddonComparisonQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<AddonComparisonQuery, AddonComparisonQueryVariables>(AddonComparisonDocument, options);
        }
export type AddonComparisonQueryHookResult = ReturnType<typeof useAddonComparisonQuery>;
export type AddonComparisonLazyQueryHookResult = ReturnType<typeof useAddonComparisonLazyQuery>;
export type AddonComparisonSuspenseQueryHookResult = ReturnType<typeof useAddonComparisonSuspenseQuery>;
export type AddonComparisonQueryResult = Apollo.QueryResult<AddonComparisonQuery, AddonComparisonQueryVariables>;
export const CarDealershipRemoveAddDocument = gql`
    mutation CarDealershipRemoveAdd($shopSessionId: UUID!, $removeOfferIds: [UUID!]!, $addOfferIds: [UUID!]!) {
  shopSessionCartEntriesRemove(
    input: {shopSessionId: $shopSessionId, offerIds: $removeOfferIds}
  ) {
    shopSession {
      cart {
        items {
          productOffer {
            id
          }
        }
      }
    }
    userError {
      ...UserError
    }
  }
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: $addOfferIds}
  ) {
    shopSession {
      cart {
        items {
          productOffer {
            id
          }
        }
      }
    }
    userError {
      ...UserError
    }
  }
}
    ${UserErrorFragmentDoc}`;
export type CarDealershipRemoveAddMutationFn = Apollo.MutationFunction<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>;

/**
 * __useCarDealershipRemoveAddMutation__
 *
 * To run a mutation, you first call `useCarDealershipRemoveAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCarDealershipRemoveAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [carDealershipRemoveAddMutation, { data, loading, error }] = useCarDealershipRemoveAddMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      removeOfferIds: // value for 'removeOfferIds'
 *      addOfferIds: // value for 'addOfferIds'
 *   },
 * });
 */
export function useCarDealershipRemoveAddMutation(baseOptions?: Apollo.MutationHookOptions<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>(CarDealershipRemoveAddDocument, options);
      }
export type CarDealershipRemoveAddMutationHookResult = ReturnType<typeof useCarDealershipRemoveAddMutation>;
export type CarDealershipRemoveAddMutationResult = Apollo.MutationResult<CarDealershipRemoveAddMutation>;
export type CarDealershipRemoveAddMutationOptions = Apollo.BaseMutationOptions<CarDealershipRemoveAddMutation, CarDealershipRemoveAddMutationVariables>;
export const CarTrialExtensionDocument = gql`
    query CarTrialExtension($contractId: UUID!) {
  carTrial(contractId: $contractId) {
    id
    collectConsent
    consentGiven
    priceIntent {
      ...PriceIntentCarTrialExtension
    }
    shopSession {
      ...ShopSession
    }
    trialContract {
      ...TrialContract
    }
  }
}
    ${PriceIntentCarTrialExtensionFragmentDoc}
${ShopSessionFragmentDoc}
${TrialContractFragmentDoc}`;

/**
 * __useCarTrialExtensionQuery__
 *
 * To run a query within a React component, call `useCarTrialExtensionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCarTrialExtensionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCarTrialExtensionQuery({
 *   variables: {
 *      contractId: // value for 'contractId'
 *   },
 * });
 */
export function useCarTrialExtensionQuery(baseOptions: Apollo.QueryHookOptions<CarTrialExtensionQuery, CarTrialExtensionQueryVariables> & ({ variables: CarTrialExtensionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>(CarTrialExtensionDocument, options);
      }
export function useCarTrialExtensionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>(CarTrialExtensionDocument, options);
        }
export function useCarTrialExtensionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>(CarTrialExtensionDocument, options);
        }
export type CarTrialExtensionQueryHookResult = ReturnType<typeof useCarTrialExtensionQuery>;
export type CarTrialExtensionLazyQueryHookResult = ReturnType<typeof useCarTrialExtensionLazyQuery>;
export type CarTrialExtensionSuspenseQueryHookResult = ReturnType<typeof useCarTrialExtensionSuspenseQuery>;
export type CarTrialExtensionQueryResult = Apollo.QueryResult<CarTrialExtensionQuery, CarTrialExtensionQueryVariables>;
export const PriceIntentDataUpdateCarDocument = gql`
    mutation PriceIntentDataUpdateCar($priceIntentId: UUID!, $data: PricingFormData!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      ...UserError
    }
  }
}
    ${PriceIntentFragmentDoc}
${UserErrorFragmentDoc}`;
export type PriceIntentDataUpdateCarMutationFn = Apollo.MutationFunction<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>;

/**
 * __usePriceIntentDataUpdateCarMutation__
 *
 * To run a mutation, you first call `usePriceIntentDataUpdateCarMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentDataUpdateCarMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentDataUpdateCarMutation, { data, loading, error }] = usePriceIntentDataUpdateCarMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePriceIntentDataUpdateCarMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>(PriceIntentDataUpdateCarDocument, options);
      }
export type PriceIntentDataUpdateCarMutationHookResult = ReturnType<typeof usePriceIntentDataUpdateCarMutation>;
export type PriceIntentDataUpdateCarMutationResult = Apollo.MutationResult<PriceIntentDataUpdateCarMutation>;
export type PriceIntentDataUpdateCarMutationOptions = Apollo.BaseMutationOptions<PriceIntentDataUpdateCarMutation, PriceIntentDataUpdateCarMutationVariables>;
export const MemberAreaMemberInfoDocument = gql`
    query MemberAreaMemberInfo {
  currentMember {
    activeContracts {
      ...MemberContract
    }
    firstName
    lastName
    email
    ssn
    paymentInformation {
      status
      connection {
        descriptor
        displayName
      }
    }
    insuranceCost {
      ...MemberInsuranceCost
    }
  }
}
    ${MemberContractFragmentDoc}
${MemberInsuranceCostFragmentDoc}`;

/**
 * __useMemberAreaMemberInfoQuery__
 *
 * To run a query within a React component, call `useMemberAreaMemberInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useMemberAreaMemberInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMemberAreaMemberInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useMemberAreaMemberInfoQuery(baseOptions?: Apollo.QueryHookOptions<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>(MemberAreaMemberInfoDocument, options);
      }
export function useMemberAreaMemberInfoLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>(MemberAreaMemberInfoDocument, options);
        }
export function useMemberAreaMemberInfoSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>(MemberAreaMemberInfoDocument, options);
        }
export type MemberAreaMemberInfoQueryHookResult = ReturnType<typeof useMemberAreaMemberInfoQuery>;
export type MemberAreaMemberInfoLazyQueryHookResult = ReturnType<typeof useMemberAreaMemberInfoLazyQuery>;
export type MemberAreaMemberInfoSuspenseQueryHookResult = ReturnType<typeof useMemberAreaMemberInfoSuspenseQuery>;
export type MemberAreaMemberInfoQueryResult = Apollo.QueryResult<MemberAreaMemberInfoQuery, MemberAreaMemberInfoQueryVariables>;
export const TravelCertificateCreateDocument = gql`
    mutation TravelCertificateCreate($input: TravelCertificateCreateInput!) {
  travelCertificateCreate(input: $input) {
    id
    signedUrl
  }
}
    `;
export type TravelCertificateCreateMutationFn = Apollo.MutationFunction<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>;

/**
 * __useTravelCertificateCreateMutation__
 *
 * To run a mutation, you first call `useTravelCertificateCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTravelCertificateCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [travelCertificateCreateMutation, { data, loading, error }] = useTravelCertificateCreateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTravelCertificateCreateMutation(baseOptions?: Apollo.MutationHookOptions<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>(TravelCertificateCreateDocument, options);
      }
export type TravelCertificateCreateMutationHookResult = ReturnType<typeof useTravelCertificateCreateMutation>;
export type TravelCertificateCreateMutationResult = Apollo.MutationResult<TravelCertificateCreateMutation>;
export type TravelCertificateCreateMutationOptions = Apollo.BaseMutationOptions<TravelCertificateCreateMutation, TravelCertificateCreateMutationVariables>;
export const CartEntriesAddDocument = gql`
    mutation CartEntriesAdd($shopSessionId: UUID!, $offerIds: [UUID!]!) {
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: $offerIds}
  ) {
    shopSession {
      id
    }
    userError {
      ...UserError
    }
  }
}
    ${UserErrorFragmentDoc}`;
export type CartEntriesAddMutationFn = Apollo.MutationFunction<CartEntriesAddMutation, CartEntriesAddMutationVariables>;

/**
 * __useCartEntriesAddMutation__
 *
 * To run a mutation, you first call `useCartEntriesAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntriesAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntriesAddMutation, { data, loading, error }] = useCartEntriesAddMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      offerIds: // value for 'offerIds'
 *   },
 * });
 */
export function useCartEntriesAddMutation(baseOptions?: Apollo.MutationHookOptions<CartEntriesAddMutation, CartEntriesAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntriesAddMutation, CartEntriesAddMutationVariables>(CartEntriesAddDocument, options);
      }
export type CartEntriesAddMutationHookResult = ReturnType<typeof useCartEntriesAddMutation>;
export type CartEntriesAddMutationResult = Apollo.MutationResult<CartEntriesAddMutation>;
export type CartEntriesAddMutationOptions = Apollo.BaseMutationOptions<CartEntriesAddMutation, CartEntriesAddMutationVariables>;
export const ShopSessionRetargetingDocument = gql`
    query ShopSessionRetargeting($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    cart {
      items {
        productOffer {
          id
        }
      }
      campaignsEnabled
    }
    priceIntents(filters: {uniqueConfirmed: true}) {
      ...RetargetingPriceIntent
    }
  }
}
    ${RetargetingPriceIntentFragmentDoc}`;

/**
 * __useShopSessionRetargetingQuery__
 *
 * To run a query within a React component, call `useShopSessionRetargetingQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionRetargetingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionRetargetingQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionRetargetingQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables> & ({ variables: ShopSessionRetargetingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>(ShopSessionRetargetingDocument, options);
      }
export function useShopSessionRetargetingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>(ShopSessionRetargetingDocument, options);
        }
export function useShopSessionRetargetingSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>(ShopSessionRetargetingDocument, options);
        }
export type ShopSessionRetargetingQueryHookResult = ReturnType<typeof useShopSessionRetargetingQuery>;
export type ShopSessionRetargetingLazyQueryHookResult = ReturnType<typeof useShopSessionRetargetingLazyQuery>;
export type ShopSessionRetargetingSuspenseQueryHookResult = ReturnType<typeof useShopSessionRetargetingSuspenseQuery>;
export type ShopSessionRetargetingQueryResult = Apollo.QueryResult<ShopSessionRetargetingQuery, ShopSessionRetargetingQueryVariables>;
export const WidgetPriceIntentDocument = gql`
    query WidgetPriceIntent($priceIntentId: UUID!) {
  priceIntent(id: $priceIntentId) {
    ...WidgetPriceIntent
  }
}
    ${WidgetPriceIntentFragmentDoc}`;

/**
 * __useWidgetPriceIntentQuery__
 *
 * To run a query within a React component, call `useWidgetPriceIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `useWidgetPriceIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useWidgetPriceIntentQuery({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function useWidgetPriceIntentQuery(baseOptions: Apollo.QueryHookOptions<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables> & ({ variables: WidgetPriceIntentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>(WidgetPriceIntentDocument, options);
      }
export function useWidgetPriceIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>(WidgetPriceIntentDocument, options);
        }
export function useWidgetPriceIntentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>(WidgetPriceIntentDocument, options);
        }
export type WidgetPriceIntentQueryHookResult = ReturnType<typeof useWidgetPriceIntentQuery>;
export type WidgetPriceIntentLazyQueryHookResult = ReturnType<typeof useWidgetPriceIntentLazyQuery>;
export type WidgetPriceIntentSuspenseQueryHookResult = ReturnType<typeof useWidgetPriceIntentSuspenseQuery>;
export type WidgetPriceIntentQueryResult = Apollo.QueryResult<WidgetPriceIntentQuery, WidgetPriceIntentQueryVariables>;
export const CartEntryAddDocument = gql`
    mutation CartEntryAdd($shopSessionId: UUID!, $offerId: UUID!) {
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: [$offerId]}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${ShopSessionFragmentDoc}
${UserErrorFragmentDoc}`;
export type CartEntryAddMutationFn = Apollo.MutationFunction<CartEntryAddMutation, CartEntryAddMutationVariables>;

/**
 * __useCartEntryAddMutation__
 *
 * To run a mutation, you first call `useCartEntryAddMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryAddMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryAddMutation, { data, loading, error }] = useCartEntryAddMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCartEntryAddMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryAddMutation, CartEntryAddMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryAddMutation, CartEntryAddMutationVariables>(CartEntryAddDocument, options);
      }
export type CartEntryAddMutationHookResult = ReturnType<typeof useCartEntryAddMutation>;
export type CartEntryAddMutationResult = Apollo.MutationResult<CartEntryAddMutation>;
export type CartEntryAddMutationOptions = Apollo.BaseMutationOptions<CartEntryAddMutation, CartEntryAddMutationVariables>;
export const CartEntryRemoveDocument = gql`
    mutation CartEntryRemove($shopSessionId: UUID!, $offerId: UUID!) {
  shopSessionCartEntriesRemove(
    input: {shopSessionId: $shopSessionId, offerIds: [$offerId]}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${ShopSessionFragmentDoc}
${UserErrorFragmentDoc}`;
export type CartEntryRemoveMutationFn = Apollo.MutationFunction<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>;

/**
 * __useCartEntryRemoveMutation__
 *
 * To run a mutation, you first call `useCartEntryRemoveMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryRemoveMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryRemoveMutation, { data, loading, error }] = useCartEntryRemoveMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      offerId: // value for 'offerId'
 *   },
 * });
 */
export function useCartEntryRemoveMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>(CartEntryRemoveDocument, options);
      }
export type CartEntryRemoveMutationHookResult = ReturnType<typeof useCartEntryRemoveMutation>;
export type CartEntryRemoveMutationResult = Apollo.MutationResult<CartEntryRemoveMutation>;
export type CartEntryRemoveMutationOptions = Apollo.BaseMutationOptions<CartEntryRemoveMutation, CartEntryRemoveMutationVariables>;
export const CartEntryReplaceDocument = gql`
    mutation CartEntryReplace($shopSessionId: UUID!, $removeOfferId: UUID!, $addOfferId: UUID!) {
  shopSessionCartEntriesRemove(
    input: {shopSessionId: $shopSessionId, offerIds: [$removeOfferId]}
  ) {
    shopSession {
      id
    }
    userError {
      ...UserError
    }
  }
  shopSessionCartEntriesAdd(
    input: {shopSessionId: $shopSessionId, offerIds: [$addOfferId]}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${UserErrorFragmentDoc}
${ShopSessionFragmentDoc}`;
export type CartEntryReplaceMutationFn = Apollo.MutationFunction<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>;

/**
 * __useCartEntryReplaceMutation__
 *
 * To run a mutation, you first call `useCartEntryReplaceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCartEntryReplaceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cartEntryReplaceMutation, { data, loading, error }] = useCartEntryReplaceMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      removeOfferId: // value for 'removeOfferId'
 *      addOfferId: // value for 'addOfferId'
 *   },
 * });
 */
export function useCartEntryReplaceMutation(baseOptions?: Apollo.MutationHookOptions<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>(CartEntryReplaceDocument, options);
      }
export type CartEntryReplaceMutationHookResult = ReturnType<typeof useCartEntryReplaceMutation>;
export type CartEntryReplaceMutationResult = Apollo.MutationResult<CartEntryReplaceMutation>;
export type CartEntryReplaceMutationOptions = Apollo.BaseMutationOptions<CartEntryReplaceMutation, CartEntryReplaceMutationVariables>;
export const RedeemCampaignDocument = gql`
    mutation RedeemCampaign($shopSessionId: UUID!, $code: String!) {
  shopSessionCartCampaignRedeem(
    input: {shopSessionId: $shopSessionId, code: $code}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${ShopSessionFragmentDoc}
${UserErrorFragmentDoc}`;
export type RedeemCampaignMutationFn = Apollo.MutationFunction<RedeemCampaignMutation, RedeemCampaignMutationVariables>;

/**
 * __useRedeemCampaignMutation__
 *
 * To run a mutation, you first call `useRedeemCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRedeemCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [redeemCampaignMutation, { data, loading, error }] = useRedeemCampaignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      code: // value for 'code'
 *   },
 * });
 */
export function useRedeemCampaignMutation(baseOptions?: Apollo.MutationHookOptions<RedeemCampaignMutation, RedeemCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RedeemCampaignMutation, RedeemCampaignMutationVariables>(RedeemCampaignDocument, options);
      }
export type RedeemCampaignMutationHookResult = ReturnType<typeof useRedeemCampaignMutation>;
export type RedeemCampaignMutationResult = Apollo.MutationResult<RedeemCampaignMutation>;
export type RedeemCampaignMutationOptions = Apollo.BaseMutationOptions<RedeemCampaignMutation, RedeemCampaignMutationVariables>;
export const UnredeemCampaignDocument = gql`
    mutation UnredeemCampaign($shopSessionId: UUID!, $campaignId: String!) {
  shopSessionCartCampaignUnredeem(
    input: {shopSessionId: $shopSessionId, campaignId: $campaignId}
  ) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${ShopSessionFragmentDoc}
${UserErrorFragmentDoc}`;
export type UnredeemCampaignMutationFn = Apollo.MutationFunction<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>;

/**
 * __useUnredeemCampaignMutation__
 *
 * To run a mutation, you first call `useUnredeemCampaignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnredeemCampaignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unredeemCampaignMutation, { data, loading, error }] = useUnredeemCampaignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      campaignId: // value for 'campaignId'
 *   },
 * });
 */
export function useUnredeemCampaignMutation(baseOptions?: Apollo.MutationHookOptions<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>(UnredeemCampaignDocument, options);
      }
export type UnredeemCampaignMutationHookResult = ReturnType<typeof useUnredeemCampaignMutation>;
export type UnredeemCampaignMutationResult = Apollo.MutationResult<UnredeemCampaignMutation>;
export type UnredeemCampaignMutationOptions = Apollo.BaseMutationOptions<UnredeemCampaignMutation, UnredeemCampaignMutationVariables>;
export const ContractDocument = gql`
    query Contract($id: UUID!) {
  contract(id: $id) {
    ...SwitchingContract
  }
}
    ${SwitchingContractFragmentDoc}`;

/**
 * __useContractQuery__
 *
 * To run a query within a React component, call `useContractQuery` and pass it any options that fit your needs.
 * When your component renders, `useContractQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useContractQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useContractQuery(baseOptions: Apollo.QueryHookOptions<ContractQuery, ContractQueryVariables> & ({ variables: ContractQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
      }
export function useContractLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ContractQuery, ContractQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
        }
export function useContractSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ContractQuery, ContractQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ContractQuery, ContractQueryVariables>(ContractDocument, options);
        }
export type ContractQueryHookResult = ReturnType<typeof useContractQuery>;
export type ContractLazyQueryHookResult = ReturnType<typeof useContractLazyQuery>;
export type ContractSuspenseQueryHookResult = ReturnType<typeof useContractSuspenseQuery>;
export type ContractQueryResult = Apollo.QueryResult<ContractQuery, ContractQueryVariables>;
export const CurrentMemberDocument = gql`
    query CurrentMember {
  currentMember {
    ...Member
  }
}
    ${MemberFragmentDoc}`;

/**
 * __useCurrentMemberQuery__
 *
 * To run a query within a React component, call `useCurrentMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentMemberQuery(baseOptions?: Apollo.QueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
      }
export function useCurrentMemberLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
        }
export function useCurrentMemberSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<CurrentMemberQuery, CurrentMemberQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CurrentMemberQuery, CurrentMemberQueryVariables>(CurrentMemberDocument, options);
        }
export type CurrentMemberQueryHookResult = ReturnType<typeof useCurrentMemberQuery>;
export type CurrentMemberLazyQueryHookResult = ReturnType<typeof useCurrentMemberLazyQuery>;
export type CurrentMemberSuspenseQueryHookResult = ReturnType<typeof useCurrentMemberSuspenseQuery>;
export type CurrentMemberQueryResult = Apollo.QueryResult<CurrentMemberQuery, CurrentMemberQueryVariables>;
export const ExternalInsurerUpdateDocument = gql`
    mutation ExternalInsurerUpdate($priceIntentId: UUID!, $externalInsurerId: ID) {
  priceIntentExternalInsurerUpdate(
    priceIntentId: $priceIntentId
    externalInsurerId: $externalInsurerId
  ) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      ...UserError
    }
  }
}
    ${PriceIntentFragmentDoc}
${UserErrorFragmentDoc}`;
export type ExternalInsurerUpdateMutationFn = Apollo.MutationFunction<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>;

/**
 * __useExternalInsurerUpdateMutation__
 *
 * To run a mutation, you first call `useExternalInsurerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useExternalInsurerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [externalInsurerUpdateMutation, { data, loading, error }] = useExternalInsurerUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      externalInsurerId: // value for 'externalInsurerId'
 *   },
 * });
 */
export function useExternalInsurerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>(ExternalInsurerUpdateDocument, options);
      }
export type ExternalInsurerUpdateMutationHookResult = ReturnType<typeof useExternalInsurerUpdateMutation>;
export type ExternalInsurerUpdateMutationResult = Apollo.MutationResult<ExternalInsurerUpdateMutation>;
export type ExternalInsurerUpdateMutationOptions = Apollo.BaseMutationOptions<ExternalInsurerUpdateMutation, ExternalInsurerUpdateMutationVariables>;
export const ExternalInsurersDocument = gql`
    query ExternalInsurers($productName: String!) {
  product(productName: $productName) {
    externalInsurers {
      id
      displayName
    }
  }
}
    `;

/**
 * __useExternalInsurersQuery__
 *
 * To run a query within a React component, call `useExternalInsurersQuery` and pass it any options that fit your needs.
 * When your component renders, `useExternalInsurersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExternalInsurersQuery({
 *   variables: {
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function useExternalInsurersQuery(baseOptions: Apollo.QueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables> & ({ variables: ExternalInsurersQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
      }
export function useExternalInsurersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
        }
export function useExternalInsurersSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ExternalInsurersQuery, ExternalInsurersQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ExternalInsurersQuery, ExternalInsurersQueryVariables>(ExternalInsurersDocument, options);
        }
export type ExternalInsurersQueryHookResult = ReturnType<typeof useExternalInsurersQuery>;
export type ExternalInsurersLazyQueryHookResult = ReturnType<typeof useExternalInsurersLazyQuery>;
export type ExternalInsurersSuspenseQueryHookResult = ReturnType<typeof useExternalInsurersSuspenseQuery>;
export type ExternalInsurersQueryResult = Apollo.QueryResult<ExternalInsurersQuery, ExternalInsurersQueryVariables>;
export const InsurelyDataCollectionCreateDocument = gql`
    mutation InsurelyDataCollectionCreate($collectionId: String!, $partner: String!) {
  insurelyInitiateIframeDataCollection(
    input: {collectionId: $collectionId, partner: $partner}
  ) {
    dataCollectionId
  }
}
    `;
export type InsurelyDataCollectionCreateMutationFn = Apollo.MutationFunction<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>;

/**
 * __useInsurelyDataCollectionCreateMutation__
 *
 * To run a mutation, you first call `useInsurelyDataCollectionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInsurelyDataCollectionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [insurelyDataCollectionCreateMutation, { data, loading, error }] = useInsurelyDataCollectionCreateMutation({
 *   variables: {
 *      collectionId: // value for 'collectionId'
 *      partner: // value for 'partner'
 *   },
 * });
 */
export function useInsurelyDataCollectionCreateMutation(baseOptions?: Apollo.MutationHookOptions<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>(InsurelyDataCollectionCreateDocument, options);
      }
export type InsurelyDataCollectionCreateMutationHookResult = ReturnType<typeof useInsurelyDataCollectionCreateMutation>;
export type InsurelyDataCollectionCreateMutationResult = Apollo.MutationResult<InsurelyDataCollectionCreateMutation>;
export type InsurelyDataCollectionCreateMutationOptions = Apollo.BaseMutationOptions<InsurelyDataCollectionCreateMutation, InsurelyDataCollectionCreateMutationVariables>;
export const OfferAddonSelectDocument = gql`
    mutation OfferAddonSelect($productOfferId: UUID!, $addonIds: [UUID!]!) {
  productOfferAddonsSelect(productOfferId: $productOfferId, addonIds: $addonIds) {
    productOffers {
      ...ProductOffer
    }
  }
}
    ${ProductOfferFragmentDoc}`;
export type OfferAddonSelectMutationFn = Apollo.MutationFunction<OfferAddonSelectMutation, OfferAddonSelectMutationVariables>;

/**
 * __useOfferAddonSelectMutation__
 *
 * To run a mutation, you first call `useOfferAddonSelectMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOfferAddonSelectMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [offerAddonSelectMutation, { data, loading, error }] = useOfferAddonSelectMutation({
 *   variables: {
 *      productOfferId: // value for 'productOfferId'
 *      addonIds: // value for 'addonIds'
 *   },
 * });
 */
export function useOfferAddonSelectMutation(baseOptions?: Apollo.MutationHookOptions<OfferAddonSelectMutation, OfferAddonSelectMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OfferAddonSelectMutation, OfferAddonSelectMutationVariables>(OfferAddonSelectDocument, options);
      }
export type OfferAddonSelectMutationHookResult = ReturnType<typeof useOfferAddonSelectMutation>;
export type OfferAddonSelectMutationResult = Apollo.MutationResult<OfferAddonSelectMutation>;
export type OfferAddonSelectMutationOptions = Apollo.BaseMutationOptions<OfferAddonSelectMutation, OfferAddonSelectMutationVariables>;
export const PriceIntentDocument = gql`
    query PriceIntent($priceIntentId: UUID!) {
  priceIntent(id: $priceIntentId) {
    ...PriceIntent
  }
}
    ${PriceIntentFragmentDoc}`;

/**
 * __usePriceIntentQuery__
 *
 * To run a query within a React component, call `usePriceIntentQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentQuery({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function usePriceIntentQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables> & ({ variables: PriceIntentQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
      }
export function usePriceIntentLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
        }
export function usePriceIntentSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PriceIntentQuery, PriceIntentQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriceIntentQuery, PriceIntentQueryVariables>(PriceIntentDocument, options);
        }
export type PriceIntentQueryHookResult = ReturnType<typeof usePriceIntentQuery>;
export type PriceIntentLazyQueryHookResult = ReturnType<typeof usePriceIntentLazyQuery>;
export type PriceIntentSuspenseQueryHookResult = ReturnType<typeof usePriceIntentSuspenseQuery>;
export type PriceIntentQueryResult = Apollo.QueryResult<PriceIntentQuery, PriceIntentQueryVariables>;
export const PriceIntentAvailableBreedsDocument = gql`
    query PriceIntentAvailableBreeds($animal: PriceIntentAnimal!) {
  priceIntentAvailableBreeds(animal: $animal) {
    ...PriceIntentAnimalBreed
  }
}
    ${PriceIntentAnimalBreedFragmentDoc}`;

/**
 * __usePriceIntentAvailableBreedsQuery__
 *
 * To run a query within a React component, call `usePriceIntentAvailableBreedsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentAvailableBreedsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceIntentAvailableBreedsQuery({
 *   variables: {
 *      animal: // value for 'animal'
 *   },
 * });
 */
export function usePriceIntentAvailableBreedsQuery(baseOptions: Apollo.QueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables> & ({ variables: PriceIntentAvailableBreedsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
      }
export function usePriceIntentAvailableBreedsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
        }
export function usePriceIntentAvailableBreedsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>(PriceIntentAvailableBreedsDocument, options);
        }
export type PriceIntentAvailableBreedsQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsQuery>;
export type PriceIntentAvailableBreedsLazyQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsLazyQuery>;
export type PriceIntentAvailableBreedsSuspenseQueryHookResult = ReturnType<typeof usePriceIntentAvailableBreedsSuspenseQuery>;
export type PriceIntentAvailableBreedsQueryResult = Apollo.QueryResult<PriceIntentAvailableBreedsQuery, PriceIntentAvailableBreedsQueryVariables>;
export const CancellationRequestedUpdateDocument = gql`
    mutation CancellationRequestedUpdate($productOfferIds: [UUID!]!, $requested: Boolean!) {
  productOffersCancellationRequestedUpdate(
    productOfferIds: $productOfferIds
    requested: $requested
  ) {
    productOffers {
      ...ProductOffer
    }
    userError {
      ...UserError
    }
  }
}
    ${ProductOfferFragmentDoc}
${UserErrorFragmentDoc}`;
export type CancellationRequestedUpdateMutationFn = Apollo.MutationFunction<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>;

/**
 * __useCancellationRequestedUpdateMutation__
 *
 * To run a mutation, you first call `useCancellationRequestedUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancellationRequestedUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancellationRequestedUpdateMutation, { data, loading, error }] = useCancellationRequestedUpdateMutation({
 *   variables: {
 *      productOfferIds: // value for 'productOfferIds'
 *      requested: // value for 'requested'
 *   },
 * });
 */
export function useCancellationRequestedUpdateMutation(baseOptions?: Apollo.MutationHookOptions<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>(CancellationRequestedUpdateDocument, options);
      }
export type CancellationRequestedUpdateMutationHookResult = ReturnType<typeof useCancellationRequestedUpdateMutation>;
export type CancellationRequestedUpdateMutationResult = Apollo.MutationResult<CancellationRequestedUpdateMutation>;
export type CancellationRequestedUpdateMutationOptions = Apollo.BaseMutationOptions<CancellationRequestedUpdateMutation, CancellationRequestedUpdateMutationVariables>;
export const PriceIntentConfirmDocument = gql`
    mutation PriceIntentConfirm($priceIntentId: UUID!) {
  priceIntentConfirm(priceIntentId: $priceIntentId) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      ...UserError
    }
  }
}
    ${PriceIntentFragmentDoc}
${UserErrorFragmentDoc}`;
export type PriceIntentConfirmMutationFn = Apollo.MutationFunction<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>;

/**
 * __usePriceIntentConfirmMutation__
 *
 * To run a mutation, you first call `usePriceIntentConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentConfirmMutation, { data, loading, error }] = usePriceIntentConfirmMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *   },
 * });
 */
export function usePriceIntentConfirmMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>(PriceIntentConfirmDocument, options);
      }
export type PriceIntentConfirmMutationHookResult = ReturnType<typeof usePriceIntentConfirmMutation>;
export type PriceIntentConfirmMutationResult = Apollo.MutationResult<PriceIntentConfirmMutation>;
export type PriceIntentConfirmMutationOptions = Apollo.BaseMutationOptions<PriceIntentConfirmMutation, PriceIntentConfirmMutationVariables>;
export const PriceIntentCreateDocument = gql`
    mutation PriceIntentCreate($shopSessionId: UUID!, $productName: String!) {
  priceIntentCreate(
    input: {shopSessionId: $shopSessionId, productName: $productName}
  ) {
    ...PriceIntent
  }
}
    ${PriceIntentFragmentDoc}`;
export type PriceIntentCreateMutationFn = Apollo.MutationFunction<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>;

/**
 * __usePriceIntentCreateMutation__
 *
 * To run a mutation, you first call `usePriceIntentCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentCreateMutation, { data, loading, error }] = usePriceIntentCreateMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *      productName: // value for 'productName'
 *   },
 * });
 */
export function usePriceIntentCreateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>(PriceIntentCreateDocument, options);
      }
export type PriceIntentCreateMutationHookResult = ReturnType<typeof usePriceIntentCreateMutation>;
export type PriceIntentCreateMutationResult = Apollo.MutationResult<PriceIntentCreateMutation>;
export type PriceIntentCreateMutationOptions = Apollo.BaseMutationOptions<PriceIntentCreateMutation, PriceIntentCreateMutationVariables>;
export const PriceIntentDataUpdateDocument = gql`
    mutation PriceIntentDataUpdate($priceIntentId: UUID!, $data: PricingFormData!, $customer: ShopSessionCustomerUpdateInput!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      ...UserError
    }
  }
  shopSessionCustomerUpdate(input: $customer) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${PriceIntentFragmentDoc}
${UserErrorFragmentDoc}
${ShopSessionFragmentDoc}`;
export type PriceIntentDataUpdateMutationFn = Apollo.MutationFunction<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>;

/**
 * __usePriceIntentDataUpdateMutation__
 *
 * To run a mutation, you first call `usePriceIntentDataUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentDataUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentDataUpdateMutation, { data, loading, error }] = usePriceIntentDataUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function usePriceIntentDataUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>(PriceIntentDataUpdateDocument, options);
      }
export type PriceIntentDataUpdateMutationHookResult = ReturnType<typeof usePriceIntentDataUpdateMutation>;
export type PriceIntentDataUpdateMutationResult = Apollo.MutationResult<PriceIntentDataUpdateMutation>;
export type PriceIntentDataUpdateMutationOptions = Apollo.BaseMutationOptions<PriceIntentDataUpdateMutation, PriceIntentDataUpdateMutationVariables>;
export const PriceIntentInsurelyUpdateDocument = gql`
    mutation PriceIntentInsurelyUpdate($priceIntentId: UUID!, $dataCollectionId: String) {
  priceIntentInsurelyUpdate(
    priceIntentId: $priceIntentId
    dataCollectionId: $dataCollectionId
  ) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      ...UserError
    }
  }
}
    ${PriceIntentFragmentDoc}
${UserErrorFragmentDoc}`;
export type PriceIntentInsurelyUpdateMutationFn = Apollo.MutationFunction<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>;

/**
 * __usePriceIntentInsurelyUpdateMutation__
 *
 * To run a mutation, you first call `usePriceIntentInsurelyUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentInsurelyUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentInsurelyUpdateMutation, { data, loading, error }] = usePriceIntentInsurelyUpdateMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      dataCollectionId: // value for 'dataCollectionId'
 *   },
 * });
 */
export function usePriceIntentInsurelyUpdateMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>(PriceIntentInsurelyUpdateDocument, options);
      }
export type PriceIntentInsurelyUpdateMutationHookResult = ReturnType<typeof usePriceIntentInsurelyUpdateMutation>;
export type PriceIntentInsurelyUpdateMutationResult = Apollo.MutationResult<PriceIntentInsurelyUpdateMutation>;
export type PriceIntentInsurelyUpdateMutationOptions = Apollo.BaseMutationOptions<PriceIntentInsurelyUpdateMutation, PriceIntentInsurelyUpdateMutationVariables>;
export const PriceIntentUpdateAndConfirmDocument = gql`
    mutation PriceIntentUpdateAndConfirm($priceIntentId: UUID!, $data: PricingFormData!) {
  priceIntentDataUpdate(priceIntentId: $priceIntentId, data: $data) {
    priceIntent {
      id
      data
    }
    userError {
      ...UserError
    }
  }
  priceIntentConfirm(priceIntentId: $priceIntentId) {
    priceIntent {
      ...PriceIntent
    }
    userError {
      ...UserError
    }
  }
}
    ${UserErrorFragmentDoc}
${PriceIntentFragmentDoc}`;
export type PriceIntentUpdateAndConfirmMutationFn = Apollo.MutationFunction<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>;

/**
 * __usePriceIntentUpdateAndConfirmMutation__
 *
 * To run a mutation, you first call `usePriceIntentUpdateAndConfirmMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `usePriceIntentUpdateAndConfirmMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [priceIntentUpdateAndConfirmMutation, { data, loading, error }] = usePriceIntentUpdateAndConfirmMutation({
 *   variables: {
 *      priceIntentId: // value for 'priceIntentId'
 *      data: // value for 'data'
 *   },
 * });
 */
export function usePriceIntentUpdateAndConfirmMutation(baseOptions?: Apollo.MutationHookOptions<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>(PriceIntentUpdateAndConfirmDocument, options);
      }
export type PriceIntentUpdateAndConfirmMutationHookResult = ReturnType<typeof usePriceIntentUpdateAndConfirmMutation>;
export type PriceIntentUpdateAndConfirmMutationResult = Apollo.MutationResult<PriceIntentUpdateAndConfirmMutation>;
export type PriceIntentUpdateAndConfirmMutationOptions = Apollo.BaseMutationOptions<PriceIntentUpdateAndConfirmMutation, PriceIntentUpdateAndConfirmMutationVariables>;
export const ProductMetadataDocument = gql`
    query ProductMetadata {
  availableProducts {
    ...Product
  }
}
    ${ProductFragmentDoc}`;

/**
 * __useProductMetadataQuery__
 *
 * To run a query within a React component, call `useProductMetadataQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductMetadataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductMetadataQuery({
 *   variables: {
 *   },
 * });
 */
export function useProductMetadataQuery(baseOptions?: Apollo.QueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
      }
export function useProductMetadataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
        }
export function useProductMetadataSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ProductMetadataQuery, ProductMetadataQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ProductMetadataQuery, ProductMetadataQueryVariables>(ProductMetadataDocument, options);
        }
export type ProductMetadataQueryHookResult = ReturnType<typeof useProductMetadataQuery>;
export type ProductMetadataLazyQueryHookResult = ReturnType<typeof useProductMetadataLazyQuery>;
export type ProductMetadataSuspenseQueryHookResult = ReturnType<typeof useProductMetadataSuspenseQuery>;
export type ProductMetadataQueryResult = Apollo.QueryResult<ProductMetadataQuery, ProductMetadataQueryVariables>;
export const SasEurobonusNumberUpdateDocument = gql`
    mutation SasEurobonusNumberUpdate($value: String!) {
  memberUpdateEurobonusNumber(input: {eurobonusNumber: $value}) {
    member {
      ...Member
    }
  }
}
    ${MemberFragmentDoc}`;
export type SasEurobonusNumberUpdateMutationFn = Apollo.MutationFunction<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>;

/**
 * __useSasEurobonusNumberUpdateMutation__
 *
 * To run a mutation, you first call `useSasEurobonusNumberUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSasEurobonusNumberUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sasEurobonusNumberUpdateMutation, { data, loading, error }] = useSasEurobonusNumberUpdateMutation({
 *   variables: {
 *      value: // value for 'value'
 *   },
 * });
 */
export function useSasEurobonusNumberUpdateMutation(baseOptions?: Apollo.MutationHookOptions<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>(SasEurobonusNumberUpdateDocument, options);
      }
export type SasEurobonusNumberUpdateMutationHookResult = ReturnType<typeof useSasEurobonusNumberUpdateMutation>;
export type SasEurobonusNumberUpdateMutationResult = Apollo.MutationResult<SasEurobonusNumberUpdateMutation>;
export type SasEurobonusNumberUpdateMutationOptions = Apollo.BaseMutationOptions<SasEurobonusNumberUpdateMutation, SasEurobonusNumberUpdateMutationVariables>;
export const ShopSessionDocument = gql`
    query ShopSession($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;

/**
 * __useShopSessionQuery__
 *
 * To run a query within a React component, call `useShopSessionQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables> & ({ variables: ShopSessionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
      }
export function useShopSessionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
        }
export function useShopSessionSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionQuery, ShopSessionQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionQuery, ShopSessionQueryVariables>(ShopSessionDocument, options);
        }
export type ShopSessionQueryHookResult = ReturnType<typeof useShopSessionQuery>;
export type ShopSessionLazyQueryHookResult = ReturnType<typeof useShopSessionLazyQuery>;
export type ShopSessionSuspenseQueryHookResult = ReturnType<typeof useShopSessionSuspenseQuery>;
export type ShopSessionQueryResult = Apollo.QueryResult<ShopSessionQuery, ShopSessionQueryVariables>;
export const ShopSessionCreateDocument = gql`
    mutation ShopSessionCreate($countryCode: CountryCode!, $attributedTo: String, $initiatedFrom: String) {
  shopSessionCreate(
    input: {countryCode: $countryCode, attributedTo: $attributedTo, initiatedFrom: $initiatedFrom}
  ) {
    ...ShopSession
  }
}
    ${ShopSessionFragmentDoc}`;
export type ShopSessionCreateMutationFn = Apollo.MutationFunction<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>;

/**
 * __useShopSessionCreateMutation__
 *
 * To run a mutation, you first call `useShopSessionCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionCreateMutation, { data, loading, error }] = useShopSessionCreateMutation({
 *   variables: {
 *      countryCode: // value for 'countryCode'
 *      attributedTo: // value for 'attributedTo'
 *      initiatedFrom: // value for 'initiatedFrom'
 *   },
 * });
 */
export function useShopSessionCreateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>(ShopSessionCreateDocument, options);
      }
export type ShopSessionCreateMutationHookResult = ReturnType<typeof useShopSessionCreateMutation>;
export type ShopSessionCreateMutationResult = Apollo.MutationResult<ShopSessionCreateMutation>;
export type ShopSessionCreateMutationOptions = Apollo.BaseMutationOptions<ShopSessionCreateMutation, ShopSessionCreateMutationVariables>;
export const ShopSessionCustomerUpdateDocument = gql`
    mutation ShopSessionCustomerUpdate($input: ShopSessionCustomerUpdateInput!) {
  shopSessionCustomerUpdate(input: $input) {
    shopSession {
      ...ShopSession
    }
    userError {
      ...UserError
    }
  }
}
    ${ShopSessionFragmentDoc}
${UserErrorFragmentDoc}`;
export type ShopSessionCustomerUpdateMutationFn = Apollo.MutationFunction<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>;

/**
 * __useShopSessionCustomerUpdateMutation__
 *
 * To run a mutation, you first call `useShopSessionCustomerUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionCustomerUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionCustomerUpdateMutation, { data, loading, error }] = useShopSessionCustomerUpdateMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useShopSessionCustomerUpdateMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>(ShopSessionCustomerUpdateDocument, options);
      }
export type ShopSessionCustomerUpdateMutationHookResult = ReturnType<typeof useShopSessionCustomerUpdateMutation>;
export type ShopSessionCustomerUpdateMutationResult = Apollo.MutationResult<ShopSessionCustomerUpdateMutation>;
export type ShopSessionCustomerUpdateMutationOptions = Apollo.BaseMutationOptions<ShopSessionCustomerUpdateMutation, ShopSessionCustomerUpdateMutationVariables>;
export const ShopSessionOutcomeDocument = gql`
    query ShopSessionOutcome($shopSessionOutcomeId: UUID!) {
  shopSessionOutcome(id: $shopSessionOutcomeId) {
    ...ShopSessionOutcome
  }
}
    ${ShopSessionOutcomeFragmentDoc}`;

/**
 * __useShopSessionOutcomeQuery__
 *
 * To run a query within a React component, call `useShopSessionOutcomeQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionOutcomeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionOutcomeQuery({
 *   variables: {
 *      shopSessionOutcomeId: // value for 'shopSessionOutcomeId'
 *   },
 * });
 */
export function useShopSessionOutcomeQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables> & ({ variables: ShopSessionOutcomeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
      }
export function useShopSessionOutcomeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
        }
export function useShopSessionOutcomeSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>(ShopSessionOutcomeDocument, options);
        }
export type ShopSessionOutcomeQueryHookResult = ReturnType<typeof useShopSessionOutcomeQuery>;
export type ShopSessionOutcomeLazyQueryHookResult = ReturnType<typeof useShopSessionOutcomeLazyQuery>;
export type ShopSessionOutcomeSuspenseQueryHookResult = ReturnType<typeof useShopSessionOutcomeSuspenseQuery>;
export type ShopSessionOutcomeQueryResult = Apollo.QueryResult<ShopSessionOutcomeQuery, ShopSessionOutcomeQueryVariables>;
export const ShopSessionOutcomeIdDocument = gql`
    query ShopSessionOutcomeId($shopSessionId: UUID!) {
  shopSession(id: $shopSessionId) {
    id
    outcome {
      id
    }
  }
}
    `;

/**
 * __useShopSessionOutcomeIdQuery__
 *
 * To run a query within a React component, call `useShopSessionOutcomeIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionOutcomeIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionOutcomeIdQuery({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionOutcomeIdQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables> & ({ variables: ShopSessionOutcomeIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>(ShopSessionOutcomeIdDocument, options);
      }
export function useShopSessionOutcomeIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>(ShopSessionOutcomeIdDocument, options);
        }
export function useShopSessionOutcomeIdSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>(ShopSessionOutcomeIdDocument, options);
        }
export type ShopSessionOutcomeIdQueryHookResult = ReturnType<typeof useShopSessionOutcomeIdQuery>;
export type ShopSessionOutcomeIdLazyQueryHookResult = ReturnType<typeof useShopSessionOutcomeIdLazyQuery>;
export type ShopSessionOutcomeIdSuspenseQueryHookResult = ReturnType<typeof useShopSessionOutcomeIdSuspenseQuery>;
export type ShopSessionOutcomeIdQueryResult = Apollo.QueryResult<ShopSessionOutcomeIdQuery, ShopSessionOutcomeIdQueryVariables>;
export const ShopSessionSigningDocument = gql`
    query ShopSessionSigning($shopSessionSigningId: UUID!) {
  shopSessionSigning(id: $shopSessionSigningId) {
    ...ShopSessionSigning
  }
}
    ${ShopSessionSigningFragmentDoc}`;

/**
 * __useShopSessionSigningQuery__
 *
 * To run a query within a React component, call `useShopSessionSigningQuery` and pass it any options that fit your needs.
 * When your component renders, `useShopSessionSigningQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useShopSessionSigningQuery({
 *   variables: {
 *      shopSessionSigningId: // value for 'shopSessionSigningId'
 *   },
 * });
 */
export function useShopSessionSigningQuery(baseOptions: Apollo.QueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables> & ({ variables: ShopSessionSigningQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
      }
export function useShopSessionSigningLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
        }
export function useShopSessionSigningSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>(ShopSessionSigningDocument, options);
        }
export type ShopSessionSigningQueryHookResult = ReturnType<typeof useShopSessionSigningQuery>;
export type ShopSessionSigningLazyQueryHookResult = ReturnType<typeof useShopSessionSigningLazyQuery>;
export type ShopSessionSigningSuspenseQueryHookResult = ReturnType<typeof useShopSessionSigningSuspenseQuery>;
export type ShopSessionSigningQueryResult = Apollo.QueryResult<ShopSessionSigningQuery, ShopSessionSigningQueryVariables>;
export const ShopSessionStartSignDocument = gql`
    mutation ShopSessionStartSign($shopSessionId: UUID!) {
  shopSessionStartSign(shopSessionId: $shopSessionId) {
    signing {
      ...ShopSessionSigning
    }
    userError {
      ...UserError
    }
  }
}
    ${ShopSessionSigningFragmentDoc}
${UserErrorFragmentDoc}`;
export type ShopSessionStartSignMutationFn = Apollo.MutationFunction<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>;

/**
 * __useShopSessionStartSignMutation__
 *
 * To run a mutation, you first call `useShopSessionStartSignMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useShopSessionStartSignMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [shopSessionStartSignMutation, { data, loading, error }] = useShopSessionStartSignMutation({
 *   variables: {
 *      shopSessionId: // value for 'shopSessionId'
 *   },
 * });
 */
export function useShopSessionStartSignMutation(baseOptions?: Apollo.MutationHookOptions<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>(ShopSessionStartSignDocument, options);
      }
export type ShopSessionStartSignMutationHookResult = ReturnType<typeof useShopSessionStartSignMutation>;
export type ShopSessionStartSignMutationResult = Apollo.MutationResult<ShopSessionStartSignMutation>;
export type ShopSessionStartSignMutationOptions = Apollo.BaseMutationOptions<ShopSessionStartSignMutation, ShopSessionStartSignMutationVariables>;
export const StartDateUpdateDocument = gql`
    mutation StartDateUpdate($productOfferIds: [UUID!]!, $startDate: Date!) {
  productOffersStartDateUpdate(
    productOfferIds: $productOfferIds
    startDate: $startDate
  ) {
    productOffers {
      ...ProductOffer
    }
    userError {
      ...UserError
    }
  }
}
    ${ProductOfferFragmentDoc}
${UserErrorFragmentDoc}`;
export type StartDateUpdateMutationFn = Apollo.MutationFunction<StartDateUpdateMutation, StartDateUpdateMutationVariables>;

/**
 * __useStartDateUpdateMutation__
 *
 * To run a mutation, you first call `useStartDateUpdateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartDateUpdateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startDateUpdateMutation, { data, loading, error }] = useStartDateUpdateMutation({
 *   variables: {
 *      productOfferIds: // value for 'productOfferIds'
 *      startDate: // value for 'startDate'
 *   },
 * });
 */
export function useStartDateUpdateMutation(baseOptions?: Apollo.MutationHookOptions<StartDateUpdateMutation, StartDateUpdateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<StartDateUpdateMutation, StartDateUpdateMutationVariables>(StartDateUpdateDocument, options);
      }
export type StartDateUpdateMutationHookResult = ReturnType<typeof useStartDateUpdateMutation>;
export type StartDateUpdateMutationResult = Apollo.MutationResult<StartDateUpdateMutation>;
export type StartDateUpdateMutationOptions = Apollo.BaseMutationOptions<StartDateUpdateMutation, StartDateUpdateMutationVariables>;
export const TrustlyInitDocument = gql`
    mutation TrustlyInit($successUrl: String!, $failureUrl: String!) {
  registerDirectDebit2(
    clientContext: {successUrl: $successUrl, failureUrl: $failureUrl}
  ) {
    url
    orderId
  }
}
    `;
export type TrustlyInitMutationFn = Apollo.MutationFunction<TrustlyInitMutation, TrustlyInitMutationVariables>;

/**
 * __useTrustlyInitMutation__
 *
 * To run a mutation, you first call `useTrustlyInitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTrustlyInitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [trustlyInitMutation, { data, loading, error }] = useTrustlyInitMutation({
 *   variables: {
 *      successUrl: // value for 'successUrl'
 *      failureUrl: // value for 'failureUrl'
 *   },
 * });
 */
export function useTrustlyInitMutation(baseOptions?: Apollo.MutationHookOptions<TrustlyInitMutation, TrustlyInitMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TrustlyInitMutation, TrustlyInitMutationVariables>(TrustlyInitDocument, options);
      }
export type TrustlyInitMutationHookResult = ReturnType<typeof useTrustlyInitMutation>;
export type TrustlyInitMutationResult = Apollo.MutationResult<TrustlyInitMutation>;
export type TrustlyInitMutationOptions = Apollo.BaseMutationOptions<TrustlyInitMutation, TrustlyInitMutationVariables>;
export const SendEventBatchDocument = gql`
    mutation SendEventBatch($inputList: [EventInput!]!) {
  sendEventBatch(inputList: $inputList)
}
    `;
export type SendEventBatchMutationFn = Apollo.MutationFunction<SendEventBatchMutation, SendEventBatchMutationVariables>;

/**
 * __useSendEventBatchMutation__
 *
 * To run a mutation, you first call `useSendEventBatchMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendEventBatchMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendEventBatchMutation, { data, loading, error }] = useSendEventBatchMutation({
 *   variables: {
 *      inputList: // value for 'inputList'
 *   },
 * });
 */
export function useSendEventBatchMutation(baseOptions?: Apollo.MutationHookOptions<SendEventBatchMutation, SendEventBatchMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendEventBatchMutation, SendEventBatchMutationVariables>(SendEventBatchDocument, options);
      }
export type SendEventBatchMutationHookResult = ReturnType<typeof useSendEventBatchMutation>;
export type SendEventBatchMutationResult = Apollo.MutationResult<SendEventBatchMutation>;
export type SendEventBatchMutationOptions = Apollo.BaseMutationOptions<SendEventBatchMutation, SendEventBatchMutationVariables>;